/**
 * OFF SPIRE - Premium Shopify 2.0 Streetwear Theme
 * Vanilla JavaScript Core Engine
 */

// Format Shopify price integer (in paise/cents) to currency string consistently as Rs. X.00
function formatMoney(cents) {
  if (isNaN(cents)) return 'Rs. 0.00';
  const rupees = (parseInt(cents, 10) / 100).toFixed(2);
  const parts = rupees.split('.');
  const integerPart = parseInt(parts[0], 10).toLocaleString('en-IN');
  return `Rs. ${integerPart}.${parts[1]}`;
}

// Modern, non-blocking toast notification banner
function showToast(message, type = 'info') {
  let container = document.getElementById('excloth-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'excloth-toast-container';
    container.style.cssText = 'position: fixed; bottom: 2rem; left: 50%; transform: translateX(-50%); z-index: 9999; display: flex; flex-direction: column; gap: 0.5rem; align-items: center; pointer-events: none; max-width: 90vw;';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  const bg = type === 'warning' ? '#111111' : '#111111';
  toast.style.cssText = `background: ${bg}; color: #FFFFFF; padding: 0.75rem 1.25rem; border-radius: 50px; font-size: 0.875rem; font-weight: 800; box-shadow: 0 10px 25px rgba(0,0,0,0.25); display: flex; align-items: center; gap: 0.5rem; opacity: 0; transform: translateY(20px); transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); pointer-events: auto;`;
  toast.innerHTML = `<span>${message}</span>`;
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}
window.showToast = showToast;

// Universal helper to parse hex codes (#1a1a1a, #f5f2eb) or map color handles to inline CSS styles
function getSwatchColorStyle(colorStr) {
  if (!colorStr) return 'background-color: #8c9095;';
  
  // Extract hex code if present (e.g. "#1a1a1a", "Dark #1b2838")
  const hexMatch = String(colorStr).match(/#([0-9a-fA-F]{3,6})/);
  if (hexMatch) {
    const hex = hexMatch[0];
    const isLight = hex.toLowerCase() === '#ffffff' || hex.toLowerCase() === '#fff' || hex.toLowerCase() === '#f5f2eb';
    return `background-color: ${hex}; ${isLight ? 'border: 1px solid #d0d0c8;' : ''}`;
  }

  const handle = String(colorStr).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
  const colorMap = {
    'black': '#1a1a1a', 'dark': '#1a1a1a', 'washed-black': '#2b2b2b', 'vintage-black': '#2b2b2b', 'faded-black': '#2b2b2b', 'carbon': '#2b2b2b',
    'ash-grey': '#8c9095', 'ash-gray': '#8c9095', 'heather-grey': '#b0b3b8', 'heather-gray': '#b0b3b8', 'grey': '#b0b3b8', 'gray': '#b0b3b8', 'slate': '#8c9095',
    'dark-grey': '#36454f', 'dark-gray': '#36454f', 'charcoal': '#36454f', 'white': '#ffffff', 'pure-white': '#ffffff', 'snow-white': '#ffffff', 'vintage-white': '#f5f2eb', 'off-white': '#f5f2eb',
    'cream': '#f5f2eb', 'ivory': '#f5f2eb', 'milk': '#f5f2eb', 'olive': '#556b2f', 'khaki': '#556b2f', 'olive-green': '#556b2f',
    'sage': '#9caf88', 'mint': '#9caf88', 'navy': '#1b2838', 'navy-blue': '#1b2838', 'dark-blue': '#1b2838', 'deep-blue': '#1b2838',
    'midnight': '#1b2838', 'midnight-blue': '#1b2838', 'blue': '#2b6cb0', 'royal-blue': '#2b6cb0', 'washed-blue': '#2b6cb0',
    'light-blue': '#87ceeb', 'sky-blue': '#87ceeb', 'baby-blue': '#87ceeb', 'red': '#d32f2f', 'dark-red': '#8b0000', 'maroon': '#800020', 'burgundy': '#800020',
    'wine': '#800020', 'pink': '#f48fb1', 'baby-pink': '#f48fb1', 'blush': '#f48fb1', 'rose': '#f48fb1', 'purple': '#7b1fa2', 'violet': '#7b1fa2', 'lavender': '#7b1fa2', 'lilac': '#7b1fa2',
    'yellow': '#fbc02d', 'mustard': '#fbc02d', 'gold': '#fbc02d', 'orange': '#e65100', 'rust': '#e65100',
    'green': '#2e5b3f', 'forest-green': '#2e5b3f', 'dark-green': '#2e5b3f', 'teal': '#00897b', 'cyan': '#00897b', 'turquoise': '#00897b',
    'brown': '#5c4033', 'mocha': '#5c4033', 'chocolate': '#5c4033', 'sand': '#d7c4b7', 'beige': '#d7c4b7', 'tan': '#d7c4b7', 'camel': '#d7c4b7'
  };

  let bgHex = colorMap[handle];
  if (!bgHex) {
    if (handle.includes('white')) bgHex = '#ffffff';
    else if (handle.includes('black')) bgHex = '#1a1a1a';
    else if (handle.includes('blue')) bgHex = '#2b6cb0';
    else if (handle.includes('green')) bgHex = '#2e5b3f';
    else if (handle.includes('red')) bgHex = '#d32f2f';
    else if (handle.includes('grey') || handle.includes('gray')) bgHex = '#8c9095';
    else if (handle.includes('pink')) bgHex = '#f48fb1';
    else if (handle.includes('purple')) bgHex = '#7b1fa2';
    else if (handle.includes('yellow')) bgHex = '#fbc02d';
    else if (handle.includes('orange')) bgHex = '#e65100';
    else if (handle.includes('brown')) bgHex = '#5c4033';
    else bgHex = (handle.length > 0 && !handle.includes('-')) ? handle : '#8c9095';
  }

  const isLight = bgHex === '#ffffff' || bgHex === '#f5f2eb' || bgHex === 'white';
  return `background-color: ${bgHex}; ${isLight ? 'border: 1px solid #d0d0c8;' : ''}`;
}

/* ------------------------------------------------------------------------
   Unified CartManager Module (Single Source of Truth across all pages)
   ------------------------------------------------------------------------ */
class CartManager {
  constructor(theme) {
    this.theme = theme;
    this.localCartKey = 'excloth_local_cart_items';
    this.state = {
      items: [],
      itemCount: 0,
      totalCents: 0,
      isSyncing: false
    };
    this.syncDebounceTimer = null;
    this.listenersAttached = false;
    this.knownCartVariants = new Set();
    this.requestSeq = 0;
  }

  init() {
    this.restoreFromCache();
    this.bindEvents();
    this.fetchCart();
  }

  restoreFromCache() {
    try {
      const raw = localStorage.getItem(this.localCartKey) || localStorage.getItem('excloth_local_cart_items_v2');
      if (raw) {
        const items = JSON.parse(raw);
        if (Array.isArray(items)) {
          this.state.items = items;
          this.recalculateFromItems();
          this.renderUI();
        }
      }
    } catch (e) {
      console.warn('CartManager restore error:', e);
    }
  }

  recalculateFromItems() {
    let count = 0;
    this.state.items.forEach(item => {
      count += (parseInt(item.quantity || '1', 10) || 0);
    });
    this.state.itemCount = count;

    let discountPercent = 0;
    if (count >= 3) {
      discountPercent = 0.30;
    } else if (count === 2) {
      discountPercent = 0.20;
    }

    let calcTotalCents = 0;
    let calcTotalDiscountCents = 0;

    this.state.items.forEach(item => {
      const qty = parseInt(item.quantity || '1', 10) || 0;
      const baseUnit = item.base_price_cents || item.original_price_cents || (item.appliedDiscountPercent > 0 && item.final_price_cents ? Math.round(item.final_price_cents / (1 - item.appliedDiscountPercent)) : item.final_price_cents) || this.parsePriceToCents(item.price);

      item.base_price_cents = baseUnit;
      item.original_price_cents = baseUnit;

      if (discountPercent > 0) {
        item.final_price_cents = Math.round(baseUnit * (1 - discountPercent));
        item.appliedDiscountPercent = discountPercent;
      } else {
        item.final_price_cents = baseUnit;
        item.appliedDiscountPercent = 0;
      }

      item.price = formatMoney(item.final_price_cents);
      item.original_price_formatted = formatMoney(item.original_price_cents);
      item.final_line_price_cents = item.final_price_cents * qty;
      item.original_line_price_cents = item.original_price_cents * qty;
      item.final_line_price_formatted = formatMoney(item.final_line_price_cents);
      item.original_line_price_formatted = formatMoney(item.original_line_price_cents);

      calcTotalCents += item.final_line_price_cents;
      calcTotalDiscountCents += (item.original_price_cents - item.final_price_cents) * qty;
    });

    this.state.totalCents = calcTotalCents;
    this.state.totalDiscountCents = calcTotalDiscountCents;
  }

  parsePriceToCents(priceStr) {
    if (!priceStr && priceStr !== 0) return 0;
    if (typeof priceStr === 'number') {
      return priceStr < 10000 ? Math.round(priceStr * 100) : Math.round(priceStr);
    }
    const cleanStr = String(priceStr).replace(/,/g, '').trim();
    const match = cleanStr.match(/(\d+(?:\.\d+)?)/);
    if (!match) return 0;
    const num = parseFloat(match[1]);
    return Math.round(num * 100);
  }

  async fetchCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      this.updateFromShopifyCart(cart);
    } catch (err) {
      console.error('CartManager fetchCart error:', err);
    }
  }

  updateFromShopifyCart(cart) {
    if (!cart) return;
    this.state.itemCount = cart.item_count || 0;
    this.knownCartVariants = new Set();

    let discountPercent = 0;
    if (this.state.itemCount >= 3) {
      discountPercent = 0.30;
    } else if (this.state.itemCount === 2) {
      discountPercent = 0.20;
    }

    if (Array.isArray(cart.items) && cart.items.length > 0) {
      let calcTotalCents = 0;
      let calcTotalDiscountCents = 0;

      const serverItemMap = new Map();
      cart.items.forEach(serverItem => {
        const vId = String(serverItem.variant_id || serverItem.id);
        if (vId) {
          this.knownCartVariants.add(vId);
          serverItemMap.set(vId, serverItem);
          if (serverItem.key) serverItemMap.set(String(serverItem.key), serverItem);
        }
      });

      const updatedItems = [];
      const processedVariantIds = new Set();

      // 1. Update items already in state preserving current frontend array order
      this.state.items.forEach(localItem => {
        const vId = String(localItem.variant_id || localItem.id);
        const serverItem = serverItemMap.get(vId) || (localItem.key ? serverItemMap.get(String(localItem.key)) : null);

        if (serverItem) {
          processedVariantIds.add(vId);
          const baseUnit = serverItem.original_price || serverItem.price || serverItem.final_price || localItem.base_price_cents || 0;
          let finalUnit = baseUnit;
          let originalUnit = baseUnit;

          if (discountPercent > 0) {
            finalUnit = Math.round(baseUnit * (1 - discountPercent));
            originalUnit = baseUnit;
          } else {
            finalUnit = serverItem.final_price !== undefined ? serverItem.final_price : baseUnit;
            originalUnit = (serverItem.original_price && serverItem.original_price > finalUnit) ? serverItem.original_price : baseUnit;
          }

          const qty = serverItem.quantity;
          const finalLine = finalUnit * qty;
          const originalLine = originalUnit * qty;

          calcTotalCents += finalLine;
          calcTotalDiscountCents += (originalUnit - finalUnit) * qty;

          updatedItems.push({
            ...localItem,
            id: vId,
            variant_id: vId,
            key: serverItem.key || localItem.key,
            title: serverItem.product_title || serverItem.title || localItem.title,
            variant_title: serverItem.variant_title || localItem.variant_title,
            price: formatMoney(finalUnit),
            original_price_formatted: formatMoney(originalUnit),
            final_price_cents: finalUnit,
            original_price_cents: originalUnit,
            base_price_cents: baseUnit,
            appliedDiscountPercent: discountPercent,
            final_line_price_cents: finalLine,
            original_line_price_cents: originalLine,
            final_line_price_formatted: formatMoney(finalLine),
            original_line_price_formatted: formatMoney(originalLine),
            quantity: qty,
            image: localItem.image || serverItem.image || '',
            url: localItem.url || serverItem.url || '',
            discounts: serverItem.discounts || [],
            color: localItem.color || this.extractOptionValue(serverItem, ['color', 'colour']),
            size: localItem.size || this.extractOptionValue(serverItem, ['size'])
          });
        }
      });

      // 2. Add any server items that weren't in local state (place new items at top)
      cart.items.forEach(serverItem => {
        const vId = String(serverItem.variant_id || serverItem.id);
        if (!processedVariantIds.has(vId)) {
          processedVariantIds.add(vId);
          const baseUnit = serverItem.original_price || serverItem.price || serverItem.final_price || 0;
          let finalUnit = baseUnit;
          let originalUnit = baseUnit;

          if (discountPercent > 0) {
            finalUnit = Math.round(baseUnit * (1 - discountPercent));
            originalUnit = baseUnit;
          } else {
            finalUnit = serverItem.final_price !== undefined ? serverItem.final_price : baseUnit;
            originalUnit = (serverItem.original_price && serverItem.original_price > finalUnit) ? serverItem.original_price : baseUnit;
          }

          const qty = serverItem.quantity;
          const finalLine = finalUnit * qty;
          const originalLine = originalUnit * qty;

          calcTotalCents += finalLine;
          calcTotalDiscountCents += (originalUnit - finalUnit) * qty;

          updatedItems.unshift({
            id: vId,
            variant_id: vId,
            key: serverItem.key,
            title: serverItem.product_title || serverItem.title,
            variant_title: serverItem.variant_title,
            price: formatMoney(finalUnit),
            original_price_formatted: formatMoney(originalUnit),
            final_price_cents: finalUnit,
            original_price_cents: originalUnit,
            base_price_cents: baseUnit,
            appliedDiscountPercent: discountPercent,
            final_line_price_cents: finalLine,
            original_line_price_cents: originalLine,
            final_line_price_formatted: formatMoney(finalLine),
            original_line_price_formatted: formatMoney(originalLine),
            quantity: qty,
            image: serverItem.image || '',
            url: serverItem.url || '',
            discounts: serverItem.discounts || [],
            color: this.extractOptionValue(serverItem, ['color', 'colour']),
            size: this.extractOptionValue(serverItem, ['size'])
          });
        }
      });

      this.state.items = updatedItems;
      this.state.totalCents = calcTotalCents;
      this.state.totalDiscountCents = calcTotalDiscountCents;
      localStorage.setItem(this.localCartKey, JSON.stringify(this.state.items));
    } else if (cart.item_count === 0) {
      this.state.items = [];
      this.state.totalCents = 0;
      this.state.totalDiscountCents = 0;
      localStorage.removeItem(this.localCartKey);
      localStorage.removeItem('excloth_local_cart_items_v2');
    }
    this.renderUI();
  }

  extractOptionValue(item, targetNames) {
    if (item.options_with_values) {
      const found = item.options_with_values.find(o => targetNames.some(t => o.name.toLowerCase().includes(t)));
      if (found) return found.value;
    }
    return '';
  }

  async addItem(variantId, quantity = 1, extraData = {}, skipDrawer = false) {
    this.state.isSyncing = true;
    this.setCheckoutButtonsState(true, '⚡ Adding to Cart...');

    // 🚀 1. Optimistically update local cart state instantly
    if (extraData && extraData.title) {
      const vId = String(variantId);
      const existing = this.state.items.find(i => String(i.variant_id || i.id) === vId);
      if (existing) {
        existing.quantity += quantity;
      } else {
        const unitCents = this.parsePriceToCents(extraData.price || '999');
        this.state.items.unshift({
          id: vId,
          variant_id: vId,
          title: extraData.title || 'Streetwear Item',
          price: extraData.price || formatMoney(unitCents),
          final_price_cents: unitCents,
          original_price_cents: unitCents,
          final_line_price_cents: unitCents * quantity,
          original_line_price_cents: unitCents * quantity,
          final_line_price_formatted: formatMoney(unitCents * quantity),
          original_line_price_formatted: formatMoney(unitCents * quantity),
          quantity: quantity,
          image: extraData.image || '',
          url: extraData.url || '/collections/all',
          color: extraData.color || '',
          size: extraData.size || ''
        });
      }
      this.recalculateFromItems();
      this.renderUI();
    }

    // 🚀 2. Open Cart Drawer IMMEDIATELY in 0ms unless explicitly skipped
    if (!skipDrawer && this.theme && typeof this.theme.openDrawer === 'function') {
      this.theme.userClosedCartDrawer = false;
      this.theme.openDrawer('cart-drawer', true);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error('Add to cart request failed');
      await this.fetchCart();
      return true;
    } catch (err) {
      console.error('CartManager.addItem error:', err);
      throw err;
    } finally {
      this.state.isSyncing = false;
      this.setCheckoutButtonsState(false);
    }
  }

  async buyNow(variantId, quantity = 1, extraData = {}) {
    this.state.isSyncing = true;
    this.setCheckoutButtonsState(true, '⚡ Preparing Checkout...');
    try {
      if (variantId && parseInt(variantId, 10) > 10) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        if (!res.ok) throw new Error('Buy Now add failed');
      }
      await this.fetchCart();
      await this.checkout();
    } catch (err) {
      console.error('CartManager.buyNow error:', err);
      throw err;
    } finally {
      this.state.isSyncing = false;
      this.setCheckoutButtonsState(false);
    }
  }

  updateQuantity(identifier, newQty, targetRow = null) {
    newQty = Math.max(0, parseInt(newQty, 10) || 0);

    const itemIndex = this.findItemIndex(identifier, targetRow);
    if (itemIndex === -1) {
      this.scheduleServerSync();
      return;
    }

    const item = this.state.items[itemIndex];
    const oldQty = item.quantity;
    if (oldQty === newQty && newQty > 0) return;

    if (newQty === 0) {
      if (targetRow) {
        targetRow.classList.add('cart-item-removing');
        setTimeout(() => {
          this.state.items.splice(itemIndex, 1);
          this.recalculateFromItems();
          localStorage.setItem(this.localCartKey, JSON.stringify(this.state.items));
          this.renderUI();
          this.scheduleServerSync();
        }, 220);
        return;
      } else {
        this.state.items.splice(itemIndex, 1);
      }
    } else {
      item.quantity = newQty;
      const unitCents = item.final_price_cents || this.parsePriceToCents(item.price);
      const origUnitCents = item.original_price_cents || unitCents;
      item.final_line_price_cents = unitCents * newQty;
      item.original_line_price_cents = origUnitCents * newQty;
      item.final_line_price_formatted = formatMoney(item.final_line_price_cents);
      item.original_line_price_formatted = formatMoney(item.original_line_price_cents);
    }

    this.recalculateFromItems();
    localStorage.setItem(this.localCartKey, JSON.stringify(this.state.items));

    if (targetRow && newQty > 0) {
      const inputs = targetRow.querySelectorAll('.quantity-input, .cart-qty-input, .main-cart-qty-input');
      inputs.forEach(input => {
        input.value = newQty;
        input.classList.remove('qty-pop');
        void input.offsetWidth;
        input.classList.add('qty-pop');
      });
      const linePriceEls = targetRow.querySelectorAll('[data-line-price]');
      linePriceEls.forEach(el => {
        el.textContent = item.final_line_price_formatted;
      });
    }

    this.renderUIQuickUpdate(item ? (item.variant_id || item.id) : null, newQty);
    this.scheduleServerSync();
  }

  renderUIQuickUpdate(updatedVariantId = null, newQty = null) {
    const { items, itemCount, totalCents } = this.state;
    const formattedSubtotal = formatMoney(totalCents);

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = itemCount;
    });

    document.querySelectorAll('[data-cart-subtotal], [data-main-cart-subtotal]').forEach(el => {
      el.textContent = formattedSubtotal;
    });

    items.forEach(item => {
      const vId = String(item.variant_id || item.id);
      document.querySelectorAll(`#cart-drawer-items-list [data-variant-id="${vId}"], .cart-items-column [data-variant-id="${vId}"]`).forEach(row => {
        const inputs = row.querySelectorAll('.quantity-input, .cart-qty-input, .main-cart-qty-input');
        inputs.forEach(input => {
          if (newQty !== null && vId === String(updatedVariantId)) input.value = item.quantity;
          input.classList.remove('qty-pop');
          void input.offsetWidth;
          input.classList.add('qty-pop');
        });
        const linePriceEls = row.querySelectorAll('[data-line-price]');
        linePriceEls.forEach(el => {
          el.textContent = item.final_line_price_formatted;
        });
        const priceContainers = row.querySelectorAll('.cart-item-price, .cart-item-pricing');
        priceContainers.forEach(container => {
          const hasDiscount = item.original_price_cents > item.final_price_cents;
          if (container.classList.contains('cart-item-pricing')) {
            container.innerHTML = `
              <span class="cart-unit-price">${item.price}</span>
              ${hasDiscount ? `<s class="cart-compare-price">${item.original_price_formatted}</s>` : ''}
            `;
          } else {
            container.innerHTML = `
              <span>${item.price}</span>
              ${hasDiscount ? `<s style="font-size: 0.775rem; color: #888888; text-decoration: line-through;">${item.original_price_formatted}</s>` : ''}
            `;
          }
        });
      });
    });

    this.updateFreeShippingBar();
    this.updateDiscountLabelsUI();
    this.updateSavingsAndShippingUI();

    const titleCountSpan = document.querySelector('.main-cart-section h1 span');
    if (titleCountSpan) {
      titleCountSpan.textContent = itemCount > 0 ? `(${itemCount} ${itemCount === 1 ? 'item' : 'items'})` : '';
    }

    window.dispatchEvent(new CustomEvent('excloth:cart:updated', {
      detail: { items, itemCount, totalCents }
    }));
  }

  scheduleServerSync() {
    this.requestSeq = (this.requestSeq || 0) + 1;
    const currentSeq = this.requestSeq;

    if (this.syncDebounceTimer) {
      clearTimeout(this.syncDebounceTimer);
      this.syncDebounceTimer = null;
    }

    this.state.isSyncing = true;
    this.syncDebounceTimer = setTimeout(async () => {
      await this.syncLocalCartToServer(currentSeq);
    }, 200);
  }

  async removeItem(identifier, targetRow = null) {
    this.updateQuantity(identifier, 0, targetRow);
  }

  async syncLocalCartToServer(expectedSeq = null) {
    if (this.syncDebounceTimer) {
      clearTimeout(this.syncDebounceTimer);
      this.syncDebounceTimer = null;
    }

    try {
      const raw = localStorage.getItem(this.localCartKey);
      if (!raw) return;
      const items = JSON.parse(raw);
      if (!Array.isArray(items)) return;

      const updates = {};
      const currentVariantIds = new Set();

      items.forEach(item => {
        const vId = String(item.variant_id || item.id);
        if (vId && parseInt(vId, 10) > 10) {
          updates[vId] = parseInt(item.quantity || '0', 10);
          currentVariantIds.add(vId);
        }
      });

      if (this.knownCartVariants && this.knownCartVariants.size > 0) {
        this.knownCartVariants.forEach(vId => {
          if (!currentVariantIds.has(vId)) {
            updates[vId] = 0;
          }
        });
      }

      if (Object.keys(updates).length > 0) {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (res.ok) {
          const cart = await res.json();
          if (expectedSeq === null || expectedSeq === this.requestSeq) {
            // Preserve active DOM elements if local optimistic item count and total match server response
            if (this.state.itemCount !== cart.item_count || Math.abs(this.state.totalCents - cart.total_price) > 5) {
              this.updateFromShopifyCart(cart);
            }
          }
        }
      }
    } catch (err) {
      console.error('CartManager.syncLocalCartToServer error:', err);
    } finally {
      this.state.isSyncing = false;
    }
  }

  async checkout() {
    this.setCheckoutButtonsState(true, '⚡ Checking out...');
    try {
      if (this.syncDebounceTimer || this.state.isSyncing) {
        if (this.syncDebounceTimer) {
          clearTimeout(this.syncDebounceTimer);
          this.syncDebounceTimer = null;
        }
        await this.syncLocalCartToServer();
      }

      const existingForm = document.getElementById('cart-drawer-form') || document.getElementById('main-cart-form');
      if (existingForm) {
        const btn = document.createElement('button');
        btn.type = 'submit';
        btn.name = 'checkout';
        btn.dataset.cartSynced = 'true';
        btn.style.display = 'none';
        existingForm.appendChild(btn);
        btn.click();
        setTimeout(() => btn.remove(), 500);
      } else {
        const form = document.createElement('form');
        form.action = '/cart';
        form.method = 'post';
        form.style.display = 'none';
        const btn = document.createElement('button');
        btn.type = 'submit';
        btn.name = 'checkout';
        btn.dataset.cartSynced = 'true';
        form.appendChild(btn);
        document.body.appendChild(form);
        btn.click();
        setTimeout(() => form.remove(), 500);
      }
    } finally {
      setTimeout(() => this.setCheckoutButtonsState(false), 2000);
    }
  }

  findItemIndex(identifier, targetRow = null) {
    if (typeof identifier === 'number' || (!isNaN(identifier) && parseInt(identifier, 10) < 100)) {
      const lineIdx = parseInt(identifier, 10) - 1;
      if (lineIdx >= 0 && lineIdx < this.state.items.length) {
        return lineIdx;
      }
    }

    if (identifier) {
      const targetStr = String(identifier).trim();
      const idx = this.state.items.findIndex(i =>
        String(i.variant_id || i.id) === targetStr || String(i.key) === targetStr
      );
      if (idx !== -1) return idx;
    }

    if (targetRow) {
      const vId = targetRow.getAttribute('data-variant-id');
      const lineAttr = targetRow.getAttribute('data-line');
      if (vId) {
        const idx = this.state.items.findIndex(i => String(i.variant_id || i.id) === String(vId));
        if (idx !== -1) return idx;
      }
      if (lineAttr) {
        const lineIdx = parseInt(lineAttr, 10) - 1;
        if (lineIdx >= 0 && lineIdx < this.state.items.length) return lineIdx;
      }
    }

    return -1;
  }

  setCheckoutButtonsState(disabled, text = null) {
    const isEmpty = (this.state.itemCount === 0);
    const checkoutBtns = document.querySelectorAll('button[name="checkout"], [data-checkout-btn]');
    checkoutBtns.forEach(btn => {
      const isActuallyDisabled = disabled || isEmpty;
      btn.disabled = isActuallyDisabled;
      if (isActuallyDisabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.removeAttribute('aria-disabled');
      }

      if (disabled && text) {
        if (!btn.dataset.origText) btn.dataset.origText = btn.innerHTML;
        btn.innerHTML = `<span>${text}</span>`;
      } else if (!disabled && btn.dataset.origText) {
        btn.innerHTML = btn.dataset.origText;
        delete btn.dataset.origText;
      }
    });
  }

  renderUI() {
    const { items, itemCount, totalCents } = this.state;
    const formattedSubtotal = formatMoney(totalCents);

    // 1. Badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = itemCount;
    });

    // 2. Subtotals across all views
    document.querySelectorAll('[data-cart-subtotal], [data-main-cart-subtotal]').forEach(el => {
      el.textContent = formattedSubtotal;
    });

    // 3. Render Cart Drawer
    this.renderCartDrawerUI();

    // 4. Render Main Cart Page
    this.renderMainCartPageUI();

    // 5. Update Free Shipping Bar & Discount Labels & Savings
    this.updateFreeShippingBar();
    this.updateDiscountLabelsUI();
    this.updateSavingsAndShippingUI();

    // 6. Update Checkout Button State (Disable if empty)
    this.setCheckoutButtonsState(false);

    // 7. Broadcast global event
    window.dispatchEvent(new CustomEvent('excloth:cart:updated', {
      detail: { items, itemCount, totalCents }
    }));
  }

  renderCartDrawerUI() {
    const drawerBody = document.querySelector('[data-cart-drawer-body]');
    if (!drawerBody) return;

    const drawerFooter = document.getElementById('cart-drawer-footer');

    if (this.state.items.length === 0) {
      if (drawerFooter) drawerFooter.style.display = 'none';
      drawerBody.innerHTML = `
        <div id="cart-drawer-empty" class="cart-drawer-empty-state">
          <div class="cart-empty-icon-circle" style="width: 64px; height: 64px; margin: 0 auto 1.25rem;">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </div>
          <h4 style="font-size: 1.15rem; font-weight: 800; color: #111111; margin: 0 0 0.35rem;">Your cart is empty</h4>
          <p style="font-size: 0.85rem; color: var(--text-muted); margin-bottom: 1.5rem; line-height: 1.4;">Add your favorite pieces to get started.</p>
          <a href="/collections/all" class="btn btn-primary btn-sm btn-ripple" data-drawer-close style="display: inline-flex; align-items: center; justify-content: center; gap: 0.4rem; text-decoration: none;">Explore Collections &rarr;</a>
        </div>
      `;
      return;
    }

    if (drawerFooter) drawerFooter.style.display = 'flex';

    const totalQty = this.state.itemCount;
    let topBannerHtml = '';

    if (totalQty >= 3) {
      topBannerHtml = `
        <div class="cart-discount-label-bar" style="background: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 6px; padding: 0.45rem 0.65rem; margin-bottom: 0.85rem; display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; font-size: 0.775rem; font-weight: 800; color: #1B5E20; min-height: 38px;">
          <span style="display: inline-flex; align-items: center; gap: 0.35rem; line-height: 1.2;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            <span>🎉 BUY 3 &amp; GET 30% OFF APPLIED!</span>
          </span>
          <span style="background: #2E7D32; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">30% OFF</span>
        </div>
      `;
    } else if (totalQty === 2) {
      topBannerHtml = `
        <div class="cart-discount-label-bar" style="background: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 6px; padding: 0.45rem 0.65rem; margin-bottom: 0.85rem; display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; font-size: 0.775rem; font-weight: 800; color: #1B5E20; min-height: 38px;">
          <span style="display: inline-flex; align-items: center; gap: 0.35rem; line-height: 1.2;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            <span>🎉 BUY 2 &amp; GET 20% OFF APPLIED! <span style="font-weight: 600; opacity: 0.9;">(Add 1 more for 30%)</span></span>
          </span>
          <span style="background: #2E7D32; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">20% OFF</span>
        </div>
      `;
    } else {
      topBannerHtml = `
        <div class="cart-discount-label-bar" style="background: #FFF8E1; border: 1px solid #FFE082; border-radius: 6px; padding: 0.45rem 0.65rem; margin-bottom: 0.85rem; display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; font-size: 0.775rem; font-weight: 800; color: #B78103; min-height: 38px;">
          <span style="display: inline-flex; align-items: center; gap: 0.35rem; line-height: 1.2;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            <span>🔥 Add 1 more item to get 20% OFF!</span>
          </span>
          <span style="background: #E65100; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">BUY 2 GET 20%</span>
        </div>
      `;
    }

    const itemsHtml = this.state.items.map((item, index) => {
      const lineNum = index + 1;
      const colName = item.color || '';
      const colStyle = getSwatchColorStyle(colName);
      const hasDiscount = item.original_price_cents > item.final_price_cents;
      const vId = item.variant_id || item.id;

      return `
        <article class="cart-drawer-item" data-variant-id="${vId}" data-line="${lineNum}">
          <a href="${item.url || '#'}" class="cart-drawer-item-media" aria-label="${item.title || ''}">
            <img src="${item.image || ''}" alt="${item.title || ''}" loading="lazy" width="76" height="101">
          </a>
          <div class="cart-drawer-item-content">
            <div class="cart-drawer-item-top">
              <span class="cart-drawer-vendor">${item.vendor || 'OFF SPIRE'}</span>
              <div class="cart-drawer-title-row">
                <h4 class="cart-drawer-product-title"><a href="${item.url || '#'}">${item.title || ''}</a></h4>
                <button type="button" class="cart-drawer-remove-icon-btn" data-cart-remove data-line="${lineNum}" data-variant-id="${vId}" data-item-key="${item.key || ''}" aria-label="Remove ${item.title || ''}" title="Remove item">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div class="cart-drawer-badges">
                ${colName ? `<span class="cart-drawer-badge"><span style="width: 8px; height: 8px; border-radius: 50%; display: inline-block; ${colStyle}"></span>Color: ${colName}</span>` : ''}
                ${item.size ? `<span class="cart-drawer-badge">Size: ${item.size}</span>` : ''}
              </div>
            </div>
            <div class="cart-drawer-item-bottom">
              <div class="cart-drawer-stepper">
                <button type="button" class="cart-drawer-stepper-btn" data-cart-qty-change="-1" data-line="${lineNum}" data-variant-id="${vId}" aria-label="Decrease quantity">&minus;</button>
                <input type="number" class="quantity-input cart-drawer-stepper-input" data-line="${lineNum}" value="${item.quantity}" min="0" readonly aria-label="Quantity">
                <button type="button" class="cart-drawer-stepper-btn" data-cart-qty-change="1" data-line="${lineNum}" data-variant-id="${vId}" aria-label="Increase quantity">&#43;</button>
              </div>
              <div class="cart-drawer-price-wrap cart-item-price">
                <span class="cart-drawer-line-price" data-line-price>${item.final_line_price_formatted}</span>
                ${hasDiscount ? `<s class="cart-drawer-unit-price">${item.original_price_formatted}</s>` : ''}
              </div>
            </div>
          </div>
        </article>
      `;
    }).join('');

    const existingForm = drawerBody.querySelector('#cart-drawer-form');
    if (existingForm) {
      const bannerEl = existingForm.querySelector('.cart-discount-label-bar');
      if (bannerEl) bannerEl.outerHTML = topBannerHtml;
      const listEl = existingForm.querySelector('#cart-drawer-items-list');
      if (listEl) listEl.innerHTML = itemsHtml;
    } else {
      drawerBody.innerHTML = `
        <div class="free-shipping-container drawer-shipping-bar" data-shipping-threshold="${parseFloat(document.body.getAttribute('data-shipping-threshold') || '150')}">
          <div class="free-shipping-text" data-shipping-text></div>
          <div class="free-shipping-bar-bg" role="progressbar" aria-label="Free shipping progress">
            <div class="free-shipping-bar-fill" data-shipping-fill style="width: 0%;"></div>
          </div>
        </div>
        <form action="/cart" method="post" id="cart-drawer-form" novalidate>
          ${topBannerHtml}
          <div class="cart-drawer-items" id="cart-drawer-items-list">${itemsHtml}</div>
        </form>
      `;
    }
  }

  renderMainCartPageUI() {
    const cartPage = document.querySelector('.main-cart-section');
    if (!cartPage) return;

    const titleCountSpan = cartPage.querySelector('.cart-page-title-count') || cartPage.querySelector('h1 span');
    const itemsList = cartPage.querySelector('#main-cart-items-list');
    const cartLayoutGrid = cartPage.querySelector('.cart-layout-grid') || cartPage.querySelector('.cart-grid-layout');

    if (this.state.items.length === 0) {
      if (titleCountSpan) titleCountSpan.textContent = '';
      if (cartLayoutGrid) {
        cartLayoutGrid.innerHTML = `
          <div class="cart-empty-container" style="grid-column: 1 / -1;">
            <div class="cart-empty-icon-circle">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            </div>
            <h2 class="cart-empty-title">Your cart is empty</h2>
            <p class="cart-empty-subtitle">Looks like you haven't added anything to your cart yet.</p>
            <a href="/collections/all" class="btn btn-primary btn-lg btn-ripple" style="display: inline-flex; align-items: center; gap: 0.5rem; text-decoration: none;">Explore Collections &rarr;</a>
          </div>
        `;
      }
      return;
    }

    if (titleCountSpan) {
      titleCountSpan.innerHTML = `(<span data-cart-count>${this.state.itemCount}</span> ${this.state.itemCount === 1 ? 'item' : 'items'})`;
    }

    const targetContainer = itemsList || cartPage.querySelector('.cart-items-column');
    if (targetContainer) {
      targetContainer.innerHTML = this.state.items.map((item, index) => {
        const lineNum = index + 1;
        const colName = item.color || '';
        const colStyle = getSwatchColorStyle(colName);
        const hasDiscount = item.original_price_cents > item.final_price_cents;
        const vId = item.variant_id || item.id;

        return `
          <article class="main-cart-item-card" data-variant-id="${vId}" data-line="${lineNum}" data-unit-price-paise="${item.final_price_cents}">
            <a href="${item.url || '#'}" class="cart-item-image-wrapper" aria-label="${item.title || ''}">
              <img src="${item.image || ''}" alt="${item.title || ''}" loading="lazy" width="110" height="146">
            </a>
            <div class="cart-item-details">
              <span class="cart-item-vendor">${item.vendor || 'OFF SPIRE'}</span>
              <h2 class="cart-item-heading"><a href="${item.url || '#'}">${item.title || ''}</a></h2>
              <div class="cart-item-badges">
                ${colName ? `<span class="cart-badge"><span class="cart-badge-swatch" style="${colStyle}"></span>Color: ${colName}</span>` : ''}
                ${item.size ? `<span class="cart-badge">Size: ${item.size}</span>` : ''}
              </div>
              <div class="cart-item-pricing">
                <span class="cart-unit-price">${item.price}</span>
                ${hasDiscount ? `<s class="cart-compare-price">${item.original_price_formatted}</s>` : ''}
              </div>
            </div>
            <div class="cart-item-actions">
              <div class="cart-line-price" data-line-price>${item.final_line_price_formatted}</div>
              <div class="cart-stepper">
                <button type="button" class="cart-stepper-btn" data-cart-qty-change="-1" data-main-cart-qty="-1" data-line="${lineNum}" data-variant-id="${vId}" aria-label="Decrease quantity">&minus;</button>
                <input type="number" class="main-cart-qty-input cart-stepper-input" data-line="${lineNum}" value="${item.quantity}" min="0" readonly aria-label="Quantity">
                <button type="button" class="cart-stepper-btn" data-cart-qty-change="1" data-main-cart-qty="1" data-line="${lineNum}" data-variant-id="${vId}" aria-label="Increase quantity">&#43;</button>
              </div>
              <button type="button" class="cart-remove-btn" data-cart-remove data-line="${lineNum}" data-variant-id="${vId}" data-item-key="${item.key || ''}" aria-label="Remove item">Remove</button>
            </div>
          </article>
        `;
      }).join('');
    }
  }

  updateFreeShippingBar() {
    const threshold = parseFloat(document.body.getAttribute('data-shipping-threshold') || '150');
    const totalAmount = this.state.totalCents / 100;
    const remaining = Math.max(0, threshold - totalAmount);
    const progress = Math.min(100, (totalAmount / threshold) * 100);

    const fillEls = document.querySelectorAll('[data-shipping-fill]');
    fillEls.forEach(el => {
      el.style.width = `${progress}%`;
    });

    const textEls = document.querySelectorAll('[data-shipping-text]');
    textEls.forEach(el => {
      if (remaining <= 0) {
        el.innerHTML = `<span>🎉 Congratulations! You unlocked <strong>FREE Shipping!</strong></span>`;
      } else {
        el.innerHTML = `<span>Add <strong>${formatMoney(remaining * 100)}</strong> more to unlock <strong>FREE Shipping!</strong></span>`;
      }
    });
  }

  updateDiscountLabelsUI() {
    const totalQty = this.state.items.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0);

    let badgeText = '';
    let bannerContent = '';

    if (totalQty >= 3) {
      badgeText = '30% OFF';
      bannerContent = `
        <span style="display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.775rem; font-weight: 800; color: #1B5E20; line-height: 1.2;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
          <span>🎉 BUY 3 &amp; GET 30% OFF APPLIED!</span>
        </span>
        <span style="background: #2E7D32; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">30% OFF</span>
      `;
    } else if (totalQty === 2) {
      badgeText = '20% OFF';
      bannerContent = `
        <span style="display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.775rem; font-weight: 800; color: #1B5E20; line-height: 1.2;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
          <span>🎉 BUY 2 &amp; GET 20% OFF APPLIED! <span style="font-weight: 600; opacity: 0.9;">(Add 1 more for 30% OFF)</span></span>
        </span>
        <span style="background: #2E7D32; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">20% OFF</span>
      `;
    } else {
      badgeText = '';
      bannerContent = `
        <span style="display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.775rem; font-weight: 800; color: #B78103; line-height: 1.2;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
          <span>🔥 Add 1 more item to get 20% OFF!</span>
        </span>
        <span style="background: #E65100; color: #FFFFFF; padding: 0.2rem 0.5rem; border-radius: 4px; font-size: 0.725rem; font-weight: 900; letter-spacing: 0.04em; white-space: nowrap; flex-shrink: 0;">BUY 2 GET 20%</span>
      `;
    }

    // 1. Update Top Banner Bars
    document.querySelectorAll('.cart-discount-label-bar').forEach(bar => {
      bar.innerHTML = bannerContent;
      if (totalQty >= 2) {
        bar.style.background = '#E8F5E9';
        bar.style.borderColor = '#C8E6C9';
      } else {
        bar.style.background = '#FFF8E1';
        bar.style.borderColor = '#FFE082';
      }
    });

    // 2. Remove side item discount badges
    document.querySelectorAll('.cart-item-discount-badge').forEach(badge => badge.remove());
  }

  updateSavingsAndShippingUI() {
    const calcSavings = this.state.totalDiscountCents || 0;
    document.querySelectorAll('[data-cart-savings]').forEach(el => {
      if (calcSavings > 0) {
        if (el.classList.contains('compact-savings-pill')) {
          el.style.display = 'inline-flex';
        } else {
          el.style.display = 'flex';
        }
        const amt = el.querySelector('[data-cart-savings-amount]');
        if (amt) {
          if (el.classList.contains('compact-savings-pill')) {
            amt.textContent = formatMoney(calcSavings);
          } else {
            amt.textContent = `-${formatMoney(calcSavings)}`;
          }
        }
      } else {
        el.style.display = 'none';
      }
    });

    const thresholdCents = parseFloat(document.body.getAttribute('data-shipping-threshold') || '150') * 100;
    const isFree = this.state.totalCents >= thresholdCents;
    document.querySelectorAll('.cart-drawer-shipping-subtext, .cart-drawer-shipping-row, .cart-summary-rows .cart-summary-row:nth-child(3)').forEach(row => {
      const freePill = row.querySelector('.shipping-free-pill');
      if (row.classList.contains('cart-drawer-shipping-subtext')) {
        if (isFree && !freePill) {
          const pill = document.createElement('span');
          pill.className = 'shipping-free-pill';
          pill.textContent = '✓ FREE SHIPPING';
          row.prepend(pill);
        } else if (!isFree && freePill) {
          freePill.remove();
        }
      } else {
        const calcLabel = row.querySelector('.shipping-calc-label');
        if (isFree) {
          if (!freePill && calcLabel) {
            calcLabel.outerHTML = `<span class="shipping-free-pill">FREE</span>`;
          }
        } else {
          if (freePill) {
            freePill.outerHTML = `<span class="shipping-calc-label">Calculated at checkout</span>`;
          }
        }
      }
    });
  }

  bindEvents() {
    if (this.listenersAttached) return;
    this.listenersAttached = true;

    // Global listener for quantity changes & remove buttons across all views
    document.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty-change], [data-main-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        const line = qtyBtn.getAttribute('data-line');
        const variantId = qtyBtn.getAttribute('data-variant-id');
        const change = parseInt(qtyBtn.getAttribute('data-cart-qty-change') || qtyBtn.getAttribute('data-main-cart-qty') || '0', 10);

        const card = qtyBtn.closest('.cart-drawer-item, .main-cart-item-card, .cart-item');
        const input = card ? card.querySelector('.quantity-input, .cart-qty-input, .main-cart-qty-input') : null;
        const currentQty = input ? parseInt(input.value || '1', 10) : 1;
        const newQty = Math.max(0, currentQty + change);

        this.updateQuantity(line || variantId, newQty, card);
      }

      // Remove button
      const removeBtn = e.target.closest('[data-cart-remove], [data-local-remove]');
      if (removeBtn) {
        e.preventDefault();
        const line = removeBtn.getAttribute('data-line');
        const variantId = removeBtn.getAttribute('data-variant-id');
        const itemKey = removeBtn.getAttribute('data-item-key');
        const card = removeBtn.closest('.cart-drawer-item, .main-cart-item-card, .cart-item');
        await this.removeItem(line || itemKey || variantId, card);
      }

      // Checkout CTA Button
      const checkoutBtn = e.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout-btn]');
      if (checkoutBtn) {
        if (checkoutBtn.dataset.cartSynced === 'true') {
          delete checkoutBtn.dataset.cartSynced;
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (this.state.itemCount === 0) {
          showToast('🛒 Your cart is empty! Add items before checking out.', 'warning');
          return;
        }

        await this.checkout();
      }
    });

    // Auto-save Order Notes
    let noteDebounceTimer = null;
    document.addEventListener('input', (e) => {
      const noteInput = e.target.closest('[data-cart-note-input]');
      if (!noteInput) return;
      if (noteDebounceTimer) clearTimeout(noteDebounceTimer);
      noteDebounceTimer = setTimeout(async () => {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: noteInput.value })
          });
        } catch (err) {
          console.error('Cart note auto-save error:', err);
        }
      }, 600);
    });
  }
}

class ExclothTheme {
  constructor() {
    this.initDrawers();
    this.initHeader();
    this.initCart();
    this.initMainCartPage();
    this.initScrollAnimations();
    this.initAccordions();
    this.initButtonRipples();
    this.initProductSwatches();
    this.initStickyATC();
    this.initModals();
    this.initCountdowns();
    this.initImageComparison();
    this.initQuickAddModal();
    this.initWishlist();
    this.initProductGallery();
    this.initPDPDescriptionToggle();
    this.initRecentlyViewed();
    this.initCollectionFilters();
    this.initOffersSlider();
    this.initProductCardSwatches();
  }

  /* ------------------------------------------------------------------------
     1. Drawer Management (Cart, Search, Mobile Menu, Filter Drawers)
     ------------------------------------------------------------------------ */
  initDrawers() {
    this.backdrop = document.querySelector('[data-drawer-backdrop]');
    this.drawers = document.querySelectorAll('[data-drawer]');
    this.triggers = document.querySelectorAll('[data-drawer-trigger]');
    this.closeBtns = document.querySelectorAll('[data-drawer-close]');

    if (this.triggers) {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = trigger.getAttribute('data-drawer-trigger');
          if (targetId === 'cart-drawer') {
            this.userClosedCartDrawer = false;
          }
          this.openDrawer(targetId, true);
        });
      });
    }

    if (this.closeBtns) {
      this.closeBtns.forEach(btn => {
        btn.addEventListener('click', () => this.closeAllDrawers(true));
      });
    }

    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-drawer-close], [data-modal-close], [data-quick-add-close], [data-lightbox-close], .modal-close-btn, .modal-close-btn-custom, .quick-add-modal__close, .drawer-close-btn, .filter-drawer__close');
      const backdropClick = e.target.closest('[data-drawer-backdrop], .drawer-backdrop, .quick-add-modal__overlay, .site-modal-overlay');
      if (closeBtn || backdropClick) {
        if (typeof this.closeQuickAddModal === 'function') this.closeQuickAddModal();
        this.closeAllDrawers(true);
      }
    });

    document.addEventListener('touchstart', (e) => {
      const closeBtn = e.target.closest('[data-drawer-close], [data-modal-close], [data-quick-add-close], [data-lightbox-close], .modal-close-btn, .modal-close-btn-custom, .quick-add-modal__close, .drawer-close-btn, .filter-drawer__close');
      if (closeBtn) {
        if (typeof this.closeQuickAddModal === 'function') this.closeQuickAddModal();
        this.closeAllDrawers(true);
      }
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeAllDrawers(true);
    });
  }

  openDrawer(drawerId, force = false) {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    if (drawerId === 'cart-drawer') {
      if (this.userClosedCartDrawer && !force) {
        return;
      }
      this.userClosedCartDrawer = false;
    }

    this.closeAllDrawers(false);
    drawer.classList.add('is-active');
    if (this.backdrop) this.backdrop.classList.add('is-active');
    document.body.classList.add('drawer-open');

    const focusableInput = drawer.querySelector('input:not([type="hidden"]), select, textarea');
    if (focusableInput) {
      setTimeout(() => focusableInput.focus(), 100);
    }
  }

  closeDrawer(drawerId) {
    if (drawerId === 'cart-drawer') {
      this.userClosedCartDrawer = true;
    }
    if (drawerId) {
      const drawer = document.getElementById(drawerId);
      if (drawer) drawer.classList.remove('is-active');
    }
    this.closeAllDrawers(true);
  }

  closeAllDrawers(isUserAction = true) {
    if (isUserAction) {
      this.userClosedCartDrawer = true;
    }
    if (this.drawers) {
      this.drawers.forEach(drawer => drawer.classList.remove('is-active'));
    }
    document.querySelectorAll('.site-modal.is-active, .quick-add-modal.is-active').forEach(modal => {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    });
    if (this.backdrop) this.backdrop.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
  }


  /* ------------------------------------------------------------------------
     2. Dynamic Header & Transparent Overlay on Scroll
     ------------------------------------------------------------------------ */
  initHeader() {
    this.header = document.querySelector('[data-site-header]');
    if (!this.header) return;

    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 50) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }

      if (currentScrollY > 200 && currentScrollY > lastScrollY) {
        this.header.classList.add('header-hidden');
      } else {
        this.header.classList.remove('header-hidden');
      }

      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  /* ------------------------------------------------------------------------
     3. Shopify AJAX Cart API & Free Shipping Calculation
     ------------------------------------------------------------------------ */
  initCart() {
    this.cartManager = new CartManager(this);
    window.CartManager = this.cartManager;
    window.ShopifyTheme = window.ShopifyTheme || {};
    window.ShopifyTheme.cartManager = this.cartManager;
    window.ShopifyTheme.saveLocalCartState = () => this.cartManager.renderUI();

    this.cartManager.init();

    // Quick add & ATC form submit listeners
    document.addEventListener('submit', (e) => {
      if (e.target.matches('[data-type="add-to-cart-form"]')) {
        e.preventDefault();
        this.handleAddToCartForm(e.target);
      }
    });

    document.addEventListener('click', (e) => {
      // Single-variant quick add → direct cart add
      const quickAddBtn = e.target.closest('[data-quick-add-id]');
      if (quickAddBtn) {
        e.preventDefault();
        const variantId = quickAddBtn.getAttribute('data-quick-add-id');
        const title = quickAddBtn.getAttribute('data-quick-add-title') || 'Streetwear Item';
        const price = quickAddBtn.getAttribute('data-quick-add-price') || 'Rs. 999.00';
        const image = quickAddBtn.getAttribute('data-quick-add-image') || '';
        const url = quickAddBtn.getAttribute('data-quick-add-url') || '/collections/all';
        const itemData = { title, price, image, url, variant_id: variantId, id: variantId };

        const originalText = quickAddBtn.textContent;
        quickAddBtn.textContent = '✓ ADDING...';
        quickAddBtn.disabled = true;
        this.cartManager.addItem(variantId, 1, itemData).then(() => {
          quickAddBtn.textContent = '✓ ADDED!';
          setTimeout(() => {
            quickAddBtn.textContent = originalText;
            quickAddBtn.disabled = false;
          }, 1500);
        }).catch(() => {
          quickAddBtn.textContent = originalText;
          quickAddBtn.disabled = false;
        });
      }

      // Multi-variant quick add → open variant picker modal
      const quickAddModalBtn = e.target.closest('[data-quick-add-modal]');
      if (quickAddModalBtn) {
        e.preventDefault();
        const handle = quickAddModalBtn.getAttribute('data-quick-add-modal');
        this.closeDrawer('wishlist-drawer');
        this.openQuickAddModal(handle, quickAddModalBtn);
      }

      // Close quick add modal via overlay or close button
      if (e.target.closest('[data-quick-add-close]')) {
        this.closeQuickAddModal();
      }
    });

    // Escape key closes quick add modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeQuickAddModal();
    });

    // In-cart Color & Size Option Switcher
    document.addEventListener('change', async (e) => {
      const colorSelect = e.target.closest('.cart-color-select');
      if (colorSelect) {
        const itemRow = colorSelect.closest('.cart-drawer-item');
        if (itemRow) {
          const newColor = colorSelect.value;
          const colorDot = itemRow.querySelector('.cart-color-dot-inline');
          const colorNameLabel = itemRow.querySelector('.cart-color-name-label');
          if (colorNameLabel) colorNameLabel.textContent = newColor;

          const colorHandle = newColor.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          const colorMap = {
            'black': '#1a1a1a',
            'washed-black': '#2b2b2b',
            'vintage-black': '#2b2b2b',
            'ash-grey': '#8c9095',
            'ash-gray': '#8c9095',
            'heather-grey': '#b0b3b8',
            'grey': '#b0b3b8',
            'gray': '#b0b3b8',
            'charcoal': '#36454f',
            'white': '#ffffff',
            'vintage-white': '#f5f2eb',
            'off-white': '#f5f2eb',
            'cream': '#f5f2eb',
            'olive': '#556b2f',
            'khaki': '#556b2f',
            'sage': '#9caf88',
            'navy': '#1b2838',
            'midnight-blue': '#1b2838',
            'blue': '#2b6cb0',
            'mocha': '#5c4033',
            'brown': '#5c4033',
            'sand': '#d7c4b7',
            'beige': '#d7c4b7',
            'tan': '#d7c4b7',
            'red': '#800020',
            'green': '#2e5b3f'
          };
          if (colorDot) colorDot.style.backgroundColor = colorMap[colorHandle] || '#8c9095';
        }
        this.saveLocalCartState();
      }

      const wishlistColorSelect = e.target.closest('.wishlist-color-input');
      if (wishlistColorSelect) {
        const itemRow = wishlistColorSelect.closest('.cart-drawer-item');
        const colorDot = itemRow ? itemRow.querySelector('.wishlist-color-dot') : null;
        if (colorDot) {
          const newColor = wishlistColorSelect.value;
          const colorHandle = newColor.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          const colorMap = {
            'black': '#1a1a1a',
            'washed-black': '#2b2b2b',
            'vintage-black': '#2b2b2b',
            'ash-grey': '#8c9095',
            'ash-gray': '#8c9095',
            'heather-grey': '#b0b3b8',
            'grey': '#b0b3b8',
            'gray': '#b0b3b8',
            'charcoal': '#36454f',
            'white': '#ffffff',
            'vintage-white': '#f5f2eb',
            'off-white': '#f5f2eb',
            'cream': '#f5f2eb',
            'olive': '#556b2f',
            'khaki': '#556b2f',
            'sage': '#9caf88',
            'navy': '#1b2838',
            'midnight-blue': '#1b2838',
            'blue': '#2b6cb0',
            'mocha': '#5c4033',
            'brown': '#5c4033',
            'sand': '#d7c4b7',
            'beige': '#d7c4b7',
            'tan': '#d7c4b7',
            'red': '#800020',
            'green': '#2e5b3f'
          };
          colorDot.style.backgroundColor = colorMap[colorHandle] || '#8c9095';
        }
      }

      const sizeSelect = e.target.closest('.cart-size-select');
      if (sizeSelect && !sizeSelect.matches('[data-change-variant]')) {
        const itemRow = sizeSelect.closest('.cart-drawer-item');
        if (itemRow) {
          const newSize = sizeSelect.value;
          const sizeLabel = itemRow.querySelector('.cart-size-name-label');
          if (sizeLabel) sizeLabel.textContent = newSize;
        }
        this.saveLocalCartState();
      }

      const variantSelect = e.target.closest('[data-change-variant]');
      if (variantSelect) {
        const line = variantSelect.getAttribute('data-line');
        const qty = parseInt(variantSelect.getAttribute('data-qty') || '1', 10);
        const newVariantId = variantSelect.value;

        variantSelect.disabled = true;
        try {
          const changeRes = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
          });
          if (changeRes.ok) {
            await this.addItemToCart(newVariantId, qty, null, true);
          }
        } catch (err) {
          console.error('Cart size swap error:', err);
        }
      }
    });

    this.initQuickAddModal();
  }

  initQuickAddModal() {
    this.quickAddModal = document.getElementById('quick-add-modal');
    this.quickAddSelectedOptions = {};
    this.quickAddVariants = [];
  }

  async openQuickAddModal(handle, triggerBtn) {
    if (!this.quickAddModal) {
      this.quickAddModal = document.getElementById('quick-add-modal');
    }
    const modal = this.quickAddModal;
    if (!modal) return;

    if (!handle && triggerBtn) {
      const card = triggerBtn.closest('.product-card, .cart-drawer-item');
      const url = triggerBtn.getAttribute('data-url') || card?.querySelector('a')?.getAttribute('href');
      if (url && url.includes('/products/')) {
        handle = url.split('/products/')[1]?.split('?')[0];
      }
    }

    if (!handle) return;

    this.quickAddActiveCard = triggerBtn ? triggerBtn.closest('.product-card') : null;

    // Find variant data from inline JSON script tag on the page
    let dataEl = document.querySelector(`.quick-add-variants-json[data-handle="${handle}"]`);
    let data = null;

    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    if (!data) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (res.ok) {
          const productData = await res.json();
          data = {
            id: productData.id,
            title: productData.title,
            handle: productData.handle,
            url: `/products/${productData.handle}`,
            image: productData.featured_image || (productData.images && productData.images.length > 0 ? (typeof productData.images[0] === 'string' ? productData.images[0] : productData.images[0].src) : ''),
            options: (productData.options || []).map((opt, idx) => ({
              name: typeof opt === 'string' ? opt : (opt.name || `Option ${idx + 1}`),
              values: typeof opt === 'string' ? Array.from(new Set((productData.variants || []).map(v => v[`option${idx + 1}`]).filter(Boolean))) : (opt.values || [])
            })),
            variants: (productData.variants || []).map(v => ({
              id: v.id,
              title: v.title,
              option1: v.option1,
              option2: v.option2,
              option3: v.option3,
              price: v.price,
              available: v.available,
              image: v.featured_image ? (typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src) : null
            }))
          };
        }
      } catch (err) {
        console.warn('Failed to fetch quick add variants:', err);
      }
    }

    if (!data) return;

    this.quickAddData = data;
    this.quickAddVariants = data.variants;
    this.quickAddSelectedOptions = {};

    // Populate modal content
    const imgEl = modal.querySelector('#QuickAddImage');
    const titleEl = modal.querySelector('#QuickAddTitle');
    const priceEl = modal.querySelector('#QuickAddPrice');
    const detailsLink = modal.querySelector('#QuickAddDetailsLink');
    const optionsEl = modal.querySelector('#QuickAddOptions');
    const atcBtn = modal.querySelector('#QuickAddCartBtn');

    if (imgEl && data.image) { imgEl.src = data.image; imgEl.alt = data.title; }
    if (titleEl) titleEl.textContent = data.title;
    const initialColorIdx = data.options ? data.options.findIndex(o => o.name.toLowerCase().includes('color') || o.name.toLowerCase().includes('colour') || o.name.toLowerCase().includes('shade')) : -1;
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.textContent = (initialColorIdx !== -1 && !this.quickAddSelectedOptions[initialColorIdx]) ? 'SELECT A COLOR' : 'SELECT A SIZE';
    }

    // Build option pickers
    optionsEl.innerHTML = '';
    data.options.forEach((option, optionIdx) => {
      const group = document.createElement('div');
      group.className = 'qa-option-group';
      group.innerHTML = `<div class="qa-option-label" style="font-size: 0.75rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.08em; color: #111111; margin-bottom: 0.5rem; text-align: left;">${option.name.toUpperCase()}</div>`;

      const swatches = document.createElement('div');
      swatches.className = 'qa-swatch-list';

      const isColor = option.name.toLowerCase().includes('color') || option.name.toLowerCase().includes('colour');

      option.values.forEach((val, vIdx) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = isColor ? 'qa-swatch-btn qa-swatch-btn--color' : 'qa-swatch-btn';
        btn.dataset.optionIdx = optionIdx;
        btn.dataset.optionVal = val;

        // Default to first option selected automatically
        if (vIdx === 0 && !this.quickAddSelectedOptions[optionIdx]) {
          this.quickAddSelectedOptions[optionIdx] = val;
          btn.classList.add('qa-selected');
        }

        if (isColor) {
          const dot = document.createElement('span');
          dot.className = 'qa-color-dot';
          const swatchStyle = getSwatchColorStyle(val);
          dot.setAttribute('style', swatchStyle);
          btn.appendChild(dot);
          const labelSpan = document.createElement('span');
          labelSpan.textContent = val;
          btn.appendChild(labelSpan);
        } else {
          btn.textContent = val;
        }

        // Check availability
        const testOpts = { ...this.quickAddSelectedOptions, [optionIdx]: val };
        const testVariant = this.quickAddVariants.find(v =>
          Object.entries(testOpts).every(([i, v2]) => v[`option${parseInt(i)+1}`] === v2)
        );
        if (testVariant && !testVariant.available) btn.classList.add('qa-unavailable');

        btn.addEventListener('click', () => {
          this.quickAddSelectedOptions[optionIdx] = val;
          swatches.querySelectorAll('.qa-swatch-btn').forEach(b => b.classList.remove('qa-selected'));
          btn.classList.add('qa-selected');

          // Update price, image, and ATC
          this.updateQuickAddATC(data.options.length);
        });

        swatches.appendChild(btn);
      });

      group.appendChild(swatches);
      optionsEl.appendChild(group);
    });

    // Auto-update price, image, and ATC button initially with default first selections
    this.updateQuickAddATC(data.options.length);

    // Update price display initially
    if (priceEl) priceEl.textContent = formatMoney(data.variants[0].price);

    // Quantity controls in Quick Add modal
    const qtyInput = modal.querySelector('#QuickAddQtyInput');
    const qtyMinusBtn = modal.querySelector('#QuickAddQtyMinus');
    const qtyPlusBtn = modal.querySelector('#QuickAddQtyPlus');

    if (qtyInput) qtyInput.value = '1';

    if (qtyMinusBtn && qtyInput) {
      qtyMinusBtn.onclick = () => {
        const cur = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, cur - 1);
      };
    }

    if (qtyPlusBtn && qtyInput) {
      qtyPlusBtn.onclick = () => {
        const cur = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = cur + 1;
      };
    }

    // ATC button click in modal (Matches PDP handleAddToCartForm 100%)
    atcBtn.onclick = () => {
      const variant = this.getSelectedQuickAddVariant();
      if (!variant) return;

      const colorOptIdx = data.options ? data.options.findIndex(o => o.name.toLowerCase().includes('color') || o.name.toLowerCase().includes('colour') || o.name.toLowerCase().includes('shade')) : -1;
      const colorOpt = (colorOptIdx !== -1 && data.options) ? data.options[colorOptIdx] : null;
      let selectedColorVal = colorOptIdx !== -1 ? this.quickAddSelectedOptions[colorOptIdx] : null;
      if (!selectedColorVal && modal) {
        const activeColorBtn = modal.querySelector('.pdp-color-btn.is-selected, [data-option-index="0"].is-selected');
        if (activeColorBtn) selectedColorVal = activeColorBtn.getAttribute('data-option-value') || activeColorBtn.querySelector('.pdp-color-name')?.textContent?.trim() || activeColorBtn.textContent.trim();
      }

      const sizeOptIdx = data.options ? data.options.findIndex(o => o.name.toLowerCase().includes('size')) : -1;
      const sizeOpt = (sizeOptIdx !== -1 && data.options) ? data.options[sizeOptIdx] : null;
      let selectedSizeVal = sizeOptIdx !== -1 ? this.quickAddSelectedOptions[sizeOptIdx] : null;
      if (!selectedSizeVal && modal) {
        const activeSizeBtn = modal.querySelector('.pdp-size-btn.is-selected, [data-option-index="1"].is-selected');
        if (activeSizeBtn) selectedSizeVal = activeSizeBtn.getAttribute('data-option-value') || activeSizeBtn.textContent.trim();
      }

      const selectedQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      const qaImgEl = modal.querySelector('#QuickAddImage');
      const activeImg = qaImgEl?.getAttribute('src') || data.image;
      const cleanColor = selectedColorVal ? selectedColorVal.split('#')[0].trim() : '';

      const modalItemData = {
        title: data.title || 'Streetwear Tee',
        price: formatMoney(variant.price),
        color: cleanColor,
        size: selectedSizeVal || 'M',
        colors: colorOpt ? colorOpt.values : (cleanColor ? [cleanColor] : []),
        sizes: sizeOpt ? sizeOpt.values : ['S', 'M', 'L', 'XL'],
        quantity: selectedQty,
        image: activeImg,
        sourceImg: qaImgEl,
        url: `/products/${data.handle || ''}`
      }; 

      atcBtn.disabled = true;
      atcBtn.textContent = '✓ ADDED TO CART!';

      this.cartManager.addItem(variant.id, selectedQty, modalItemData).catch(err => {
        console.error('Quick Add ATC error:', err);
      });

      setTimeout(() => {
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        this.closeQuickAddModal();
      }, 1200);
    };

    // Quick Add Modal Buy Now Button Handler
    const buyNowBtn = modal.querySelector('#QuickAddBuyNowBtn');
    if (buyNowBtn) {
      buyNowBtn.onclick = async () => {
        const variant = this.getSelectedQuickAddVariant();
        if (!variant || !variant.available) return;
        const selectedQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        this.closeQuickAddModal();
        await this.handleBuyNow(buyNowBtn, variant.id, selectedQty);
      };
    }

    // Show modal
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }

  updateQuickAddATC(totalOptions) {
    const modal = this.quickAddModal;
    if (!modal) return;
    const atcBtn = modal.querySelector('#QuickAddCartBtn');
    const buyNowBtn = modal.querySelector('#QuickAddBuyNowBtn');
    const priceEl = modal.querySelector('#QuickAddPrice');
    const imgEl = modal.querySelector('#QuickAddImage');

    const variant = this.getSelectedQuickAddVariant();
    const allSelected = Object.keys(this.quickAddSelectedOptions).length === totalOptions;

    // Dynamically update image when color/options are selected (4-step waterfall)
    let selectedVariantImg = '';
    if (variant) {
      selectedVariantImg = variant.image || (variant.featured_image ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src) : '');
    }

    const colorOptIdx = this.quickAddData && this.quickAddData.options ? this.quickAddData.options.findIndex(o => o.name.toLowerCase().includes('color') || o.name.toLowerCase().includes('colour') || o.name.toLowerCase().includes('shade')) : -1;
    const selectedColorVal = colorOptIdx !== -1 ? this.quickAddSelectedOptions[colorOptIdx] : null;

    // 2. Sibling variant matching selected color
    if (!selectedVariantImg && selectedColorVal && Array.isArray(this.quickAddVariants)) {
      const colorV = this.quickAddVariants.find(v => 
        (v.option1 === selectedColorVal || v.option2 === selectedColorVal || v.option3 === selectedColorVal || (v.title && v.title.includes(selectedColorVal))) &&
        (v.image || v.featured_image)
      );
      if (colorV) {
        selectedVariantImg = colorV.image || (colorV.featured_image ? (typeof colorV.featured_image === 'string' ? colorV.featured_image : colorV.featured_image.src) : '');
      }
    }

    // 3. Search product images / media by color name or alt
    if (!selectedVariantImg && selectedColorVal && this.quickAddData) {
      const cleanColorName = selectedColorVal.toLowerCase().replace(/[^a-z0-9]/g, '');
      const allImages = this.quickAddData.images || this.quickAddData.media || [];
      if (Array.isArray(allImages) && allImages.length > 0) {
        const matchedImg = allImages.find(img => {
          const imgUrl = (typeof img === 'string' ? img : (img.src || img.preview_image?.src || '')).toLowerCase();
          const imgAlt = (typeof img === 'object' && img.alt ? img.alt : '').toLowerCase();
          return imgUrl.includes(cleanColorName) || imgAlt.includes(cleanColorName) || imgUrl.includes(selectedColorVal.toLowerCase());
        });
        if (matchedImg) {
          selectedVariantImg = typeof matchedImg === 'string' ? matchedImg : (matchedImg.src || matchedImg.preview_image?.src || '');
        }
      }
    }

    // 4. Check card swatch dot data-variant-img attribute
    if (!selectedVariantImg && selectedColorVal && this.quickAddActiveCard) {
      const swatchDot = this.quickAddActiveCard.querySelector(`[data-card-swatch][data-color-val="${selectedColorVal}"]`);
      if (swatchDot) {
        const swatchImg = swatchDot.getAttribute('data-variant-img');
        if (swatchImg) selectedVariantImg = swatchImg;
      }
    }

    if (imgEl && selectedVariantImg) {
      imgEl.src = selectedVariantImg;
    }

    // Also update active product card image if card reference exists
    if (this.quickAddActiveCard && selectedVariantImg) {
      const primaryImg = this.quickAddActiveCard.querySelector('.product-card-img.primary-img');
      if (primaryImg) primaryImg.src = selectedVariantImg;
    }

    const hasColorSelected = colorOptIdx !== -1 ? Boolean(this.quickAddSelectedOptions[colorOptIdx]) : true;

    const sizeOptIdx = this.quickAddData && this.quickAddData.options ? this.quickAddData.options.findIndex(o => o.name.toLowerCase().includes('size')) : -1;
    const hasSizeSelected = sizeOptIdx !== -1 ? Boolean(this.quickAddSelectedOptions[sizeOptIdx]) : true;

    const setBtnState = (atcText, buyNowText, isDis) => {
      if (atcBtn) {
        atcBtn.disabled = isDis;
        atcBtn.textContent = atcText;
        if (isDis) atcBtn.classList.add('is-disabled'); else atcBtn.classList.remove('is-disabled');
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = isDis;
        const span = buyNowBtn.querySelector('span');
        if (span) span.textContent = buyNowText;
        if (isDis) buyNowBtn.classList.add('is-disabled'); else buyNowBtn.classList.remove('is-disabled');
      }
    };

    if (!hasColorSelected) {
      setBtnState('SELECT A COLOR', 'SELECT A COLOR', true);
      return;
    }

    if (!hasSizeSelected) {
      setBtnState('SELECT A SIZE', 'SELECT A SIZE', true);
      return;
    }

    if (!allSelected) {
      setBtnState('SELECT OPTIONS', 'SELECT OPTIONS', true);
      return;
    }

    if (!variant || !variant.available) {
      setBtnState('SOLD OUT', 'SOLD OUT', true);
    } else {
      setBtnState(`ADD TO CART — ${formatMoney(variant.price)}`, 'BUY IT NOW', false);
    }
    if (priceEl && variant) priceEl.textContent = formatMoney(variant.price);
  }

  getSelectedQuickAddVariant() {
    return this.quickAddVariants.find(v =>
      Object.entries(this.quickAddSelectedOptions).every(([i, val]) =>
        v[`option${parseInt(i)+1}`] === val
      )
    );
  }

  closeQuickAddModal() {
    const modal = this.quickAddModal;
    if (!modal) return;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    this.quickAddSelectedOptions = {};
    this.quickAddVariants = [];
  }

  async handleAddToCartForm(form, skipDrawer = false) {
    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer');

    const variantIdInput = form.querySelector('[data-product-variant-input], [name="id"]');
    const selectedVariantId = variantIdInput ? variantIdInput.value : (formData.get('id') || '');
    const qtyVal = Math.max(1, parseInt(formData.get('quantity') || '1', 10));

    // Extract selected color & size
    const colorBtn = form.querySelector('.pdp-option-section--color .pdp-color-btn.is-selected, .pdp-color-btn.is-selected, [data-option-btn].is-selected');
    const colorLabelEl = form.querySelector('.pdp-option-section--color [data-selected-option-value]') || document.querySelector('.pdp-option-section--color [data-selected-option-value]');
    const colorBtnElements = Array.from(form.querySelectorAll('.pdp-option-section--color .pdp-color-btn, .pdp-color-btn'));
    const colorBtns = colorBtnElements.map(b => b.getAttribute('data-option-value') || b.querySelector('.pdp-color-name')?.textContent?.trim() || b.textContent?.trim()).filter(Boolean);

    let selectedColor = colorBtn ? (colorBtn.getAttribute('data-option-value') || colorBtn.querySelector('.pdp-color-name')?.textContent?.trim() || colorBtn.textContent?.trim()) : '';
    if (!selectedColor && colorLabelEl) selectedColor = colorLabelEl.textContent?.trim();
    if (!selectedColor) selectedColor = colorBtns[0] || 'Black';

    const sizeBtn = form.querySelector('.pdp-option-section--size .pdp-size-btn.is-selected, .pdp-size-btn.is-selected, [name*="Option"]:checked, [name*="option"]:checked');
    const sizeBtnElements = Array.from(form.querySelectorAll('.pdp-option-section--size .pdp-size-btn, .pdp-size-btn'));
    const sizeBtns = sizeBtnElements.map(b => b.getAttribute('data-option-value') || b.textContent?.trim()).filter(Boolean);
    const selectedSize = sizeBtn ? (sizeBtn.getAttribute('data-option-value') || sizeBtn.value || sizeBtn.textContent?.trim()) : (sizeBtns[0] || 'M');

    // Extract PDP title & price
    const pdpTitle = document.querySelector('.pdp-product-title')?.textContent?.trim() || 'Streetwear Tee';
    const curPriceEl = document.querySelector('.pdp-price-current');
    let pdpPrice = curPriceEl ? curPriceEl.textContent.trim() : '';
    if (!pdpPrice) {
      const fullText = document.querySelector('[data-product-price]')?.textContent?.trim() || '';
      const match = fullText.match(/(?:Rs\.?|₹|\$)\s*[\d,]+(?:\.\d+)?/i);
      pdpPrice = match ? match[0] : 'Rs. 999.00';
    }

    // Extract variant-matched image
    let pdpImage = '';
    let sourceImgEl = null;

    if (selectedVariantId) {
      const variantScripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
      for (const script of variantScripts) {
        try {
          const parsed = JSON.parse(script.textContent);
          const variants = Array.isArray(parsed) ? parsed : (parsed && Array.isArray(parsed.variants) ? parsed.variants : []);
          const matchedV = variants.find(v => String(v.id) === String(selectedVariantId));
          if (matchedV) {
            pdpImage = matchedV.featured_image?.src || matchedV.featured_media?.preview_image?.src || '';
            if (pdpImage) break;
          }
        } catch(e) {}
      }
    }

    if (selectedColor) {
      const cleanColor = selectedColor.toLowerCase().replace(/[^a-z0-9]+/g, '');
      sourceImgEl = Array.from(document.querySelectorAll('[data-product-gallery] img, .product-single-media-item img')).find(img => {
        const alt = (img.getAttribute('alt') || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
        const slideColor = (img.closest('[data-color]')?.getAttribute('data-color') || img.getAttribute('data-color') || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
        return (alt && alt.includes(cleanColor)) || (slideColor && slideColor.includes(cleanColor));
      });
      if (sourceImgEl && !pdpImage) pdpImage = sourceImgEl.getAttribute('src') || '';
    }

    if (!sourceImgEl) {
      sourceImgEl = document.querySelector('[data-product-gallery] .is-active img, .product-single-media-item.is-active img, [data-product-gallery] img, .pdp-gallery-main img');
    }

    if (!pdpImage && sourceImgEl) {
      pdpImage = sourceImgEl.getAttribute('src') || sourceImgEl.src || '';
    }

    const pdpItem = {
      title: pdpTitle,
      price: pdpPrice,
      color: selectedColor,
      size: selectedSize,
      colors: colorBtns.length > 0 ? Array.from(new Set(colorBtns)) : [selectedColor],
      sizes: sizeBtns.length > 0 ? Array.from(new Set(sizeBtns)) : [selectedSize],
      quantity: qtyVal,
      image: pdpImage,
      variant_id: selectedVariantId,
      id: selectedVariantId
    };

    const submitBtn = form.querySelector('[type="submit"]');
    const btnTextEl = submitBtn?.querySelector('[data-atc-btn-text]') || submitBtn;
    const originalContent = btnTextEl ? btnTextEl.innerHTML : '';

    if (submitBtn) {
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
      if (btnTextEl) btnTextEl.innerHTML = '⚡ ADDING...';
    }

    try {
      const variantId = formData.get('id') || selectedVariantId;
      if (variantId) {
        await this.cartManager.addItem(variantId, qtyVal, pdpItem, skipDrawer);
      }

      if (submitBtn) {
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-added');
        if (btnTextEl) btnTextEl.innerHTML = '✓ ADDED TO CART!';
      }

      setTimeout(() => {
        if (submitBtn) {
          submitBtn.classList.remove('is-added');
          submitBtn.disabled = false;
          if (btnTextEl) btnTextEl.innerHTML = originalContent;
        }
      }, 1800);
    } catch (err) {
      console.error('Shopify ATC error:', err);
      this.renderLocalCartItem(pdpItem);
      if (submitBtn) {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        if (btnTextEl) btnTextEl.innerHTML = originalContent;
      }
    }
  }

  async addItemToCart(variantId, quantity = 1, itemData = null, skipDrawer = false) {
    if (this.cartManager) {
      return this.cartManager.addItem(variantId, quantity, itemData, skipDrawer);
    }
  }

  updateCartDrawerFromSection(html) {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer || !html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('#cart-drawer');
    if (newDrawer) {
      // Always update footer & subtotal in real-time
      const currentFooter = drawer.querySelector('#cart-drawer-footer');
      const newFooter = newDrawer.querySelector('#cart-drawer-footer');
      if (currentFooter && newFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      const newCounts = newDrawer.querySelectorAll('[data-cart-count]');
      if (newCounts.length > 0) {
        const newCountVal = newCounts[0].textContent;
        document.querySelectorAll('[data-cart-count]').forEach(b => {
          b.textContent = newCountVal;
        });
      }

      // Only skip body update during active rapid tap sequence
      if (this.pendingQtyCount && this.pendingQtyCount > 0) {
        return;
      }

      const currentBody = drawer.querySelector('[data-cart-drawer-body]');
      const newBody = newDrawer.querySelector('[data-cart-drawer-body]');
      if (currentBody && newBody) {
        currentBody.innerHTML = newBody.innerHTML;
        this.saveLocalCartState();
      }
    }
  }


  initMainCartPage() {
    if (this.cartManager) {
      this.cartManager.renderMainCartPageUI();
    }
  }

  async handleBuyNow(buyNowBtn, variantId, quantity = 1) {
    if (!buyNowBtn || buyNowBtn.disabled) return;
    const originalHTML = buyNowBtn.innerHTML;
    buyNowBtn.disabled = true;
    buyNowBtn.innerHTML = '⚡ PREPARING CHECKOUT...';

    const restore = () => {
      if (buyNowBtn) {
        buyNowBtn.disabled = false;
        buyNowBtn.innerHTML = originalHTML;
      }
    };

    try {
      await this.cartManager.buyNow(variantId, quantity);
    } catch (err) {
      console.error('Buy Now failed:', err);
    } finally {
      setTimeout(restore, 1500);
      window.addEventListener('focus', restore, { once: true });
    }
  }

  renderLocalCartItem(item, shouldSave = true) {
    if (this.cartManager) {
      return this.cartManager.fetchCart();
    }
  }

  saveLocalCartState() {
    if (this.cartManager) {
      return this.cartManager.renderUI();
    }
  }

  restoreLocalCartItems() {
    if (this.cartManager) {
      return this.cartManager.restoreFromCache();
    }
  }

  syncLocalCartToServer() {
    if (this.cartManager) {
      return this.cartManager.syncLocalCartToServer();
    }
  }

  setCheckoutButtonsState(disabled, text = null) {
    if (this.cartManager) {
      return this.cartManager.setCheckoutButtonsState(disabled, text);
    }
  }

  addItemToCart(variantId, quantity = 1, extraData = {}, skipDrawer = false) {
    if (this.cartManager) {
      return this.cartManager.addItem(variantId, quantity, extraData, skipDrawer);
    }
  }

  updateCartItem(line, quantity) {
    if (this.cartManager) {
      return this.cartManager.updateQuantity(line, quantity);
    }
  }

  async refreshCart() {
    if (this.cartManager) {
      return this.cartManager.fetchCart();
    }
  }

  /* ------------------------------------------------------------------------
     4. Scroll Animations (IntersectionObserver for .animate-fade-up)
     ------------------------------------------------------------------------ */
  initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.animate-fade-up');
    if (!animatedElements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animatedElements.forEach(el => observer.observe(el));
  }

  /* ------------------------------------------------------------------------
     5. Accordions (Product Details, FAQ)
     ------------------------------------------------------------------------ */
  initAccordions() {
    document.addEventListener('click', (e) => {
      const header = e.target.closest('[data-accordion-header]');
      if (header) {
        const item = header.closest('.accordion-item');
        if (item) {
          const isActive = item.classList.contains('is-active');
          
          // Optional: close siblings
          const container = item.closest('[data-accordion-group]');
          if (container) {
            container.querySelectorAll('.accordion-item').forEach(child => child.classList.remove('is-active'));
          }

          if (!isActive) item.classList.add('is-active');
        }
      }
    });
  }

  /* ------------------------------------------------------------------------
     6. Button Ripple Animation
     ------------------------------------------------------------------------ */
  initButtonRipples() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.btn-ripple');
      if (btn) {
        const circle = document.createElement('span');
        const diameter = Math.max(btn.clientWidth, btn.clientHeight);
        const radius = diameter / 2;
        const rect = btn.getBoundingClientRect();

        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${e.clientX - rect.left - radius}px`;
        circle.style.top = `${e.clientY - rect.top - radius}px`;
        circle.classList.add('ripple-effect');

        const ripple = btn.querySelector('.ripple-effect');
        if (ripple) ripple.remove();

        btn.appendChild(circle);
      }
    });
  }

  /* ------------------------------------------------------------------------
     7. Dynamic Variant Selector Engine
     ------------------------------------------------------------------------ */
  initProductSwatches() {
    const variantDataEl = document.getElementById('ProductVariantsJson');
    if (!variantDataEl) return;

    const variants = JSON.parse(variantDataEl.textContent);
    const form = document.getElementById('ProductForm');
    if (!form) return;

    // Track currently selected option values per option index
    // Initialise from the currently selected swatch buttons
    const selectedOptions = {};
    form.querySelectorAll('[data-option-btn].is-selected').forEach(btn => {
      const idx = btn.getAttribute('data-option-index');
      selectedOptions[idx] = btn.getAttribute('data-option-value');
    });

    // Parse hex codes if present in option value strings (e.g. Dark Blue #1B2838)
    form.querySelectorAll('.pdp-color-btn').forEach(btn => {
      const val = (btn.getAttribute('data-option-value') || '').trim();
      const dot = btn.querySelector('.pdp-color-dot');
      if (!val || !dot) return;
      const hexMatch = val.match(/#([0-9a-fA-F]{3,6})/);
      if (hexMatch) {
        dot.style.backgroundColor = hexMatch[0];
      }
    });

    // Find a variant that matches all selected options
    const findVariant = () => {
      return variants.find(v => {
        return Object.entries(selectedOptions).every(([idx, val]) => {
          return v[`option${parseInt(idx) + 1}`] === val;
        });
      });
    };

    // Update UI after a selection change
    const updateVariantUI = () => {
      const variant = findVariant();

      // Update hidden input
      const idInput = form.querySelector('[data-product-variant-input]');
      if (idInput) idInput.value = variant ? variant.id : '';

      // Update price display
      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && variant) {
        const curPriceSpan = priceEl.querySelector('.pdp-price-current');
        const comparePriceSpan = priceEl.querySelector('.pdp-price-compare');
        const discountBadge = priceEl.querySelector('.pdp-discount-badge');
        const savingsBadge = priceEl.querySelector('.pdp-savings-badge');

        if (curPriceSpan) {
          curPriceSpan.textContent = formatMoney(variant.price);
        }

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const savings = variant.compare_at_price - variant.price;
          const discountPercent = Math.round((savings * 100) / variant.compare_at_price);

          if (comparePriceSpan) {
            comparePriceSpan.textContent = formatMoney(variant.compare_at_price);
            comparePriceSpan.style.display = 'inline';
          }
          if (discountBadge) {
            discountBadge.textContent = `-${discountPercent}% OFF`;
            discountBadge.style.display = 'inline-block';
          }
          if (savingsBadge) {
            savingsBadge.textContent = `Save ${formatMoney(savings)}`;
            savingsBadge.style.display = 'inline-flex';
          }
        } else {
          if (comparePriceSpan) comparePriceSpan.style.display = 'none';
          if (discountBadge) discountBadge.style.display = 'none';
          if (savingsBadge) savingsBadge.style.display = 'none';
        }
      }

      // Update ATC button price text
      const atcPrice = document.querySelector('[data-atc-price]');
      if (atcPrice && variant) atcPrice.textContent = formatMoney(variant.price);

      // Update sticky bar prices (both in meta text and inside button)
      const stickyPrices = document.querySelectorAll('[data-sticky-price], [data-sticky-btn-price]');
      if (stickyPrices.length && variant) {
        stickyPrices.forEach(el => el.textContent = formatMoney(variant.price));
      }

      // Dynamically update Sticky Footer Bar image based on selected color variant
      const stickyImg = document.querySelector('.sticky-atc-img');
      if (stickyImg && variant) {
        let variantImgSrc = '';
        if (variant.featured_image && variant.featured_image.src) {
          variantImgSrc = variant.featured_image.src;
        } else if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
          variantImgSrc = variant.featured_media.preview_image.src;
        }

        if (!variantImgSrc) {
          const selectedColorBtn = form.querySelector('.pdp-option-section--color .pdp-color-btn.is-selected, .pdp-color-btn.is-selected, [data-option-btn].is-selected');
          const selectedColorName = selectedColorBtn ? (selectedColorBtn.getAttribute('data-option-value') || selectedColorBtn.textContent?.trim()) : '';
          if (selectedColorName) {
            const cleanColor = selectedColorName.toLowerCase().replace(/[^a-z0-9]+/g, '');
            const matchingImg = Array.from(document.querySelectorAll('[data-product-gallery] img, .product-single-media-item img')).find(img => {
              const alt = (img.getAttribute('alt') || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
              const slideColor = (img.closest('[data-color]')?.getAttribute('data-color') || img.getAttribute('data-color') || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
              return (alt && alt.includes(cleanColor)) || (slideColor && slideColor.includes(cleanColor));
            });
            if (matchingImg) variantImgSrc = matchingImg.getAttribute('src');
          }
        }

        if (!variantImgSrc) {
          const activeSlideImg = document.querySelector('[data-product-gallery] .is-active img, .product-single-media-item.is-active img');
          if (activeSlideImg) variantImgSrc = activeSlideImg.getAttribute('src');
        }

        if (variantImgSrc) {
          stickyImg.src = variantImgSrc;
        }
      }

      // Update sticky bar selected color & size badges in real time
      const stickyColorText = document.querySelector('[data-sticky-selected-color]');
      const stickyColorDot = document.querySelector('[data-sticky-color-dot]');
      const stickySizeText = document.querySelector('[data-sticky-selected-size]');

      const selectedColorBtn = form.querySelector('.pdp-option-section--color .pdp-color-btn.is-selected, .pdp-color-btn.is-selected');
      const selectedColorVal = selectedColorBtn ? (selectedColorBtn.getAttribute('data-option-value') || selectedColorBtn.textContent?.trim()) : '';

      const selectedSizeBtn = form.querySelector('.pdp-option-section--size .pdp-size-btn.is-selected, .pdp-size-btn.is-selected, [name*="Option"]:checked, [name*="option"]:checked');
      const selectedSizeVal = selectedSizeBtn ? (selectedSizeBtn.getAttribute('data-option-value') || selectedSizeBtn.value || selectedSizeBtn.textContent?.trim()) : '';

      if (stickyColorText && selectedColorVal) {
        stickyColorText.textContent = selectedColorVal;
      }
      if (stickyColorDot && selectedColorVal) {
        const swatchStyle = getSwatchColorStyle(selectedColorVal);
        stickyColorDot.setAttribute('style', `width: 8px; height: 8px; border-radius: 50%; display: inline-block; ${swatchStyle}`);
      }
      if (stickySizeText && selectedSizeVal) {
        stickySizeText.textContent = selectedSizeVal;
      }

      // Update ATC button state
      const atcBtn = document.getElementById('AddToCartBtn');
      const stickyBtn = document.querySelector('[data-sticky-atc-btn]');

      if (atcBtn) {
        if (!variant) {
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled');
          atcBtn.querySelector('[data-atc-btn-text]').textContent = 'UNAVAILABLE';
        } else if (!variant.available) {
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled');
          atcBtn.querySelector('[data-atc-btn-text]').textContent = 'SOLD OUT';
        } else {
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-disabled');
          atcBtn.querySelector('[data-atc-btn-text]').innerHTML = `ADD TO CART — <span data-atc-price>${formatMoney(variant.price)}</span>`;
        }
      }

      // Update Buy Now button state on PDP
      const buyNowBtn = document.getElementById('BuyNowBtn');
      if (buyNowBtn) {
        const buyNowTextEl = buyNowBtn.querySelector('span') || buyNowBtn;
        if (!variant) {
          buyNowBtn.disabled = true;
          buyNowBtn.classList.add('is-disabled');
          if (buyNowTextEl) buyNowTextEl.textContent = 'UNAVAILABLE';
        } else if (!variant.available) {
          buyNowBtn.disabled = true;
          buyNowBtn.classList.add('is-disabled');
          if (buyNowTextEl) buyNowTextEl.textContent = 'SOLD OUT';
        } else {
          buyNowBtn.disabled = false;
          buyNowBtn.classList.remove('is-disabled');
          if (buyNowTextEl) buyNowTextEl.textContent = 'BUY IT NOW';
        }
      }

      if (stickyBtn) {
        if (!variant || !variant.available) {
          stickyBtn.disabled = true;
          stickyBtn.classList.add('is-disabled');
          const contentEl = stickyBtn.querySelector('.sticky-atc-btn-content') || stickyBtn;
          if (contentEl) contentEl.textContent = !variant ? 'UNAVAILABLE' : 'SOLD OUT';
        } else {
          stickyBtn.disabled = false;
          stickyBtn.classList.remove('is-disabled');
          const contentEl = stickyBtn.querySelector('.sticky-atc-btn-content') || stickyBtn;
          if (contentEl) contentEl.innerHTML = `ADD TO CART <span data-sticky-btn-price>— ${formatMoney(variant.price)}</span>`;
        }
      }

      // Mark sold-out swatches
      form.querySelectorAll('[data-option-btn]').forEach(btn => {
        const idx = parseInt(btn.getAttribute('data-option-index'));
        const val = btn.getAttribute('data-option-value');

        // Build a test selection with this value swapped in
        const testOptions = { ...selectedOptions, [idx]: val };
        const testVariant = variants.find(v =>
          Object.entries(testOptions).every(([i, v2]) => v[`option${parseInt(i) + 1}`] === v2)
        );

        btn.classList.toggle('is-unavailable', testVariant ? !testVariant.available : false);
      });

      // Update Product Gallery photo based on selected color or variant media
      const activeColorBtn = form.querySelector('.pdp-color-btn.is-selected, [data-option-btn].is-selected[data-option-value]');
      const galleryColorVal = activeColorBtn ? (activeColorBtn.getAttribute('data-option-value') || activeColorBtn.querySelector('.pdp-color-name')?.textContent?.trim() || activeColorBtn.textContent.trim()) : selectedColorVal;
      const variantMediaId = variant ? (variant.featured_media?.id || variant.featured_image?.id) : null;

      const galleries = document.querySelectorAll('[data-product-gallery]');
      galleries.forEach(g => {
        if (g._galleryController) {
          g._galleryController.switchImageByColor(galleryColorVal, variantMediaId);
        }
      });
    };

    // Listen for swatch button clicks
    form.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option-btn]') || e.target.closest('.pdp-size-btn') || e.target.closest('.pdp-color-btn');
      if (!btn) return;

      const idx = btn.getAttribute('data-option-index') || '0';
      const val = btn.getAttribute('data-option-value') || btn.textContent.trim();

      // Update selected options state
      selectedOptions[idx] = val;

      // Update is-selected class within this option group
      const group = btn.closest('.pdp-color-grid') || btn.closest('.pdp-size-grid') || btn.closest('.variant-swatch-list') || btn.parentElement;
      if (group) {
        group.querySelectorAll('[data-option-btn], .pdp-size-btn, .pdp-color-btn').forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      }

      // Update selected value label
      const section = btn.closest('.pdp-option-section') || btn.closest('.pdp-size-section') || btn.closest('.variant-picker-section') || btn.parentElement?.closest('[data-option-index]');
      const valueLabel = section?.querySelector('[data-selected-option-value]');
      if (valueLabel) valueLabel.textContent = val;

      updateVariantUI();
      this.updateHighlightedSizeRow();
    });

    // Run once on load to init state
    updateVariantUI();

    // Global listener for color button clicks (works for both dynamic forms and demo mode selectors)
    document.addEventListener('click', (e) => {
      const colorBtn = e.target.closest('.pdp-color-btn');
      if (!colorBtn) return;
      const colorVal = colorBtn.getAttribute('data-option-value') || colorBtn.querySelector('.pdp-color-name')?.textContent?.trim() || colorBtn.textContent.trim();
      if (colorVal) {
        const galleries = document.querySelectorAll('[data-product-gallery]');
        galleries.forEach(g => {
          if (g._galleryController) {
            g._galleryController.switchImageByColor(colorVal, null);
          }
        });
      }
    });

    // Global listener for Buy Now button
    document.addEventListener('click', async (e) => {
      const buyNowBtn = e.target.closest('#BuyNowBtn, [data-buy-now-btn]');
      if (!buyNowBtn) return;
      e.preventDefault();

      const form = buyNowBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
      const variantIdInput = form ? form.querySelector('[data-product-variant-input], [name="id"]') : null;
      const variantId = variantIdInput ? variantIdInput.value : (form ? (new FormData(form)).get('id') : '');
      const qtyInput = form ? form.querySelector('[name="quantity"], .pdp-qty-input') : null;
      const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      if (variantId) {
        await this.handleBuyNow(buyNowBtn, variantId, quantity);
      }
    });

    // Checkout form submit handler
    // Checkout form submit validation
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form#cart-drawer-form, form#main-cart-form');
      if (!form) return;
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      const rawLocalCart = localStorage.getItem('excloth_local_cart_items') || localStorage.getItem('excloth_local_cart_items_v2');
      let totalQtyInCart = 0;
      if (rawLocalCart) {
        try {
          const parsed = JSON.parse(rawLocalCart);
          if (Array.isArray(parsed)) {
            totalQtyInCart = parsed.reduce((sum, item) => sum + (parseInt(item.quantity || '1', 10) || 0), 0);
          }
        } catch (ex) {}
      }

      if (totalQtyInCart === 0) {
        e.preventDefault();
        showToast('🛒 Your cart is empty! Add items before checking out.', 'warning');
        return;
      }
    });
  }

  /* ------------------------------------------------------------------------
     PDP Description Collapsible Fade Toggle
     ------------------------------------------------------------------------ */
  initPDPDescriptionToggle() {
    const wrappers = document.querySelectorAll('[data-pdp-desc-wrapper]');
    if (!wrappers.length) return;

    wrappers.forEach(wrapper => {
      const content = wrapper.querySelector('[data-pdp-desc-content]');
      const toggleBtn = wrapper.querySelector('[data-pdp-desc-toggle]');
      const toggleText = wrapper.querySelector('[data-pdp-toggle-text]');
      const fade = wrapper.querySelector('[data-pdp-desc-fade]');
      if (!toggleBtn || !content) return;

      const inner = wrapper.querySelector('.pdp-description-inner');
      if (inner && inner.scrollHeight <= 95) {
        content.style.maxHeight = 'none';
        if (fade) fade.style.display = 'none';
        toggleBtn.style.display = 'none';
        return;
      }

      toggleBtn.addEventListener('click', () => {
        const isExpanded = wrapper.classList.contains('is-expanded');
        if (isExpanded) {
          wrapper.classList.remove('is-expanded');
          toggleBtn.setAttribute('aria-expanded', 'false');
          if (toggleText) toggleText.textContent = 'Read More';
        } else {
          wrapper.classList.add('is-expanded');
          toggleBtn.setAttribute('aria-expanded', 'true');
          if (toggleText) toggleText.textContent = 'Read Less';
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Recently Viewed Products Tracking & Rendering Engine
     ------------------------------------------------------------------------ */
  initRecentlyViewed() {
    // 1. Store current product to localStorage history if on product page
    const currentDataEl = document.getElementById('RecentlyViewedProductData');
    if (currentDataEl) {
      try {
        const prodData = JSON.parse(currentDataEl.textContent);
        if (prodData && prodData.handle) {
          let history = JSON.parse(localStorage.getItem('offspire_recently_viewed') || '[]');
          history = history.filter(item => item.handle !== prodData.handle);
          history.unshift(prodData);
          if (history.length > 8) history = history.slice(0, 8);
          localStorage.setItem('offspire_recently_viewed', JSON.stringify(history));
        }
      } catch (e) {
        console.error('Error saving recently viewed product:', e);
      }
    }

    // 2. Render recently viewed items dynamically inside [data-recently-viewed-container]
    const container = document.querySelector('[data-recently-viewed-container]');
    if (!container) return;

    try {
      const history = JSON.parse(localStorage.getItem('offspire_recently_viewed') || '[]');
      const currentHandle = currentDataEl ? JSON.parse(currentDataEl.textContent)?.handle : null;
      const displayItems = history.filter(item => item.handle !== currentHandle).slice(0, 4);

      if (displayItems.length > 0) {
        container.innerHTML = displayItems.map(item => `
          <div class="product-card animate-fade-up is-visible">
            <div class="product-card-media img-zoom-wrapper">
              <a href="${item.url}" class="product-card-link" aria-label="${item.title}">
                <img src="${item.image || 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=600&q=80'}" alt="${item.title}" class="product-card-img primary-img" loading="lazy" width="600" height="800">
              </a>
              <div class="product-card-quick-add">
                <a href="${item.url}" class="btn btn-primary btn-sm btn-full btn-ripple">View Product</a>
              </div>
            </div>
            <div class="product-card-info">
              <span class="product-card-vendor">${item.vendor || 'OFF SPIRE'}</span>
              <h3 class="product-card-title"><a href="${item.url}">${item.title}</a></h3>
              <div class="product-card-price">
                ${item.compare_at_price ? `<span style="color: var(--color-sale); margin-right: 0.35rem;">${item.price}</span><span class="price-compare">${item.compare_at_price}</span>` : `<span>${item.price}</span>`}
              </div>
            </div>
          </div>
        `).join('');
      }
    } catch (e) {
      console.error('Error rendering recently viewed products:', e);
    }
  }

  /* ------------------------------------------------------------------------
     8. Sticky Add-to-Cart Bar on PDP
     ------------------------------------------------------------------------ */
  initStickyATC() {
    const mainATC = document.querySelector('[data-main-atc-btn]');
    const stickyBar = document.querySelector('[data-sticky-atc-bar]');
    if (!stickyBar) return;

    if (mainATC) {
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      }, { threshold: 0 });

      observer.observe(mainATC);
    }

    // Native HTML5 input.stepUp() / stepDown() handler
    document.addEventListener('click', (e) => {
      const stepBtn = e.target.closest('[data-qty-step]');
      if (stepBtn) {
        e.preventDefault();
        const dir = stepBtn.getAttribute('data-qty-step');
        const container = stepBtn.parentElement;
        const input = container ? container.querySelector('input[type="number"], input[name="quantity"]') : null;
        if (input) {
          if (dir === '+') {
            if (typeof input.stepUp === 'function') {
              input.stepUp();
            } else {
              input.value = (parseInt(input.value, 10) || 1) + 1;
            }
          } else {
            if (typeof input.stepDown === 'function') {
              input.stepDown();
            } else {
              input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
            }
          }
          const mainInput = document.querySelector('input[name="quantity"]');
          const stickyInput = document.querySelector('[data-sticky-qty-input]');
          if (mainInput && stickyInput) {
            if (input === mainInput) stickyInput.value = mainInput.value;
            if (input === stickyInput) mainInput.value = stickyInput.value;
          }
        }
      }
    });

    // Sticky Add to Cart button click -> Delegates to handleAddToCartForm for exact color, size, and image sync
    const stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    const stickyQtyInput = stickyBar.querySelector('[data-sticky-qty-input]');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const mainForm = document.querySelector('form[action*="/cart/add"], form.shopify-product-form, .pdp-form');
        if (mainForm) {
          const mainQtyInput = mainForm.querySelector('input[name="quantity"]');
          if (mainQtyInput && stickyQtyInput) {
            mainQtyInput.value = stickyQtyInput.value;
          }
          this.handleAddToCartForm(mainForm);
        } else {
          const variantIdInput = document.getElementById('ProductVariantId') || document.querySelector('[data-product-variant-input]');
          const variantId = variantIdInput ? variantIdInput.value : null;
          const qty = stickyQtyInput ? (parseInt(stickyQtyInput.value, 10) || 1) : 1;
          if (variantId) this.addItemToCart(variantId, qty);
        }
      });
    }
  }

  /* ------------------------------------------------------------------------
     9. Modals (Size Guide, Quick View)
     ------------------------------------------------------------------------ */
  initModals() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-trigger');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.add('is-active');
          if (modalId === 'size-guide-modal') {
            this.updateHighlightedSizeRow();
          }
          if (this.backdrop) this.backdrop.classList.add('is-active');
          document.body.classList.add('drawer-open');
        }
      }

      const closeBtn = e.target.closest('[data-modal-close], .modal-close-btn, .modal-close-btn-custom');
      if (closeBtn) {
        this.closeQuickAddModal();
        this.closeAllDrawers(true);
      }
    });
  }

  updateHighlightedSizeRow() {
    const sizeModal = document.getElementById('size-guide-modal');
    if (!sizeModal) return;

    const selectedBtn = document.querySelector('.pdp-size-btn.is-selected, [data-option-btn].is-selected');
    const selectedSize = selectedBtn ? (selectedBtn.getAttribute('data-option-value') || selectedBtn.textContent.trim()).toUpperCase() : 'S';

    const rows = sizeModal.querySelectorAll('[data-size-row]');
    let foundMatch = false;

    rows.forEach(row => {
      const rowSize = row.getAttribute('data-size-row').toUpperCase();
      if (rowSize === selectedSize) {
        row.classList.add('highlight-row');
        foundMatch = true;
      } else {
        row.classList.remove('highlight-row');
      }
    });

    if (!foundMatch && rows.length > 0) {
      rows[0].classList.add('highlight-row');
    }
  }

  /* ------------------------------------------------------------------------
     10. Countdown Timers
     ------------------------------------------------------------------------ */
  initCountdowns() {
    const countdowns = document.querySelectorAll('[data-countdown-date]');
    countdowns.forEach(el => {
      const targetDate = new Date(el.getAttribute('data-countdown-date')).getTime();
      
      const updateTimer = () => {
        const now = new Date().getTime();
        const diff = targetDate - now;

        if (diff <= 0) {
          el.innerHTML = '<span class="countdown-expired">Drop Live Now</span>';
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const daysEl = el.querySelector('[data-days]');
        const hoursEl = el.querySelector('[data-hours]');
        const minsEl = el.querySelector('[data-minutes]');
        const secsEl = el.querySelector('[data-seconds]');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      };

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }

  /* ------------------------------------------------------------------------
     11. Image Comparison / Split Slider
     ------------------------------------------------------------------------ */
  initImageComparison() {
    const sliders = document.querySelectorAll('[data-image-comparison]');
    sliders.forEach(container => {
      const handle = container.querySelector('[data-comparison-handle]');
      const overlay = container.querySelector('[data-comparison-overlay]');

      if (!handle || !overlay) return;

      let isDragging = false;

      const move = (clientX) => {
        const rect = container.getBoundingClientRect();
        let position = ((clientX - rect.left) / rect.width) * 100;
        position = Math.max(0, Math.min(100, position));

        overlay.style.width = `${position}%`;
        handle.style.left = `${position}%`;
      };

      handle.addEventListener('mousedown', () => isDragging = true);
      window.addEventListener('mouseup', () => isDragging = false);
      window.addEventListener('mousemove', (e) => {
        if (isDragging) move(e.clientX);
      });

      handle.addEventListener('touchstart', () => isDragging = true);
      window.addEventListener('touchend', () => isDragging = false);
      window.addEventListener('touchmove', (e) => {
        if (isDragging && e.touches[0]) move(e.touches[0].clientX);
      });
    });
  }

  /* ------------------------------------------------------------------------
     12. Dynamic Wishlist Engine (localStorage, Active State & Drawer Sync)
     ------------------------------------------------------------------------ */
  initWishlist() {
    this.wishlistKey = 'excloth_wishlist_items';

    // Auto-sync with logged-in customer metafields if available
    if (window.ShopifyTheme?.customer?.wishlist && Array.isArray(window.ShopifyTheme.customer.wishlist) && window.ShopifyTheme.customer.wishlist.length > 0) {
      const localItems = this.getWishlistItems();
      const merged = [...window.ShopifyTheme.customer.wishlist, ...localItems];
      const unique = merged.filter((item, index, self) => index === self.findIndex(t => t.title === item.title));
      localStorage.setItem(this.wishlistKey, JSON.stringify(unique));
    }

    this.renderWishlistDrawer();
    this.updateWishlistActiveButtons();

    document.addEventListener('click', (e) => {
      // Toggle Wishlist Button (Card or PDP)
      const toggleBtn = e.target.closest('[data-wishlist-toggle], [data-wishlist-add]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const card = toggleBtn.closest('.product-card') || toggleBtn.closest('.product-single-details') || document;
        const title = toggleBtn.getAttribute('data-title') || card.querySelector('.product-card-title, .product-single-title')?.textContent?.trim() || 'Streetwear Item';
        const price = toggleBtn.getAttribute('data-price') || card.querySelector('.product-card-price, [data-product-price]')?.textContent?.trim() || 'Rs. 999.00';
        const comparePrice = toggleBtn.getAttribute('data-compare-price') || card.querySelector('.product-card-compare-price, .pdp-price-compare')?.textContent?.trim() || '';
        
        const rawColors = toggleBtn.getAttribute('data-colors') || '';
        let colors = rawColors ? rawColors.split('|').map(c => c.trim()).filter(Boolean) : [];

        const rawSizes = toggleBtn.getAttribute('data-sizes') || 'XS|S|M|L|XL|2XL|3XL';
        let sizes = rawSizes ? rawSizes.split('|').map(s => s.trim()).filter(Boolean) : ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

        // Clean up sizes & extract embedded colors
        sizes = sizes.map(s => {
          if (s.includes('/')) {
            const parts = s.split('/');
            if (parts[1] && !colors.includes(parts[1].trim())) {
              colors.push(parts[1].trim());
            }
            return parts[0].trim();
          }
          return s;
        });

        sizes = Array.from(new Set(sizes.filter(Boolean)));
        colors = Array.from(new Set(colors.filter(Boolean)));

        if (colors.length === 0) {
          const activeColorBtn = document.querySelector('.pdp-color-btn.is-selected');
          const activeColor = activeColorBtn ? (activeColorBtn.getAttribute('data-option-value') || activeColorBtn.textContent.trim()) : 'Ash Grey';
          colors = [activeColor];
        }

        const color = colors[0];
        const size = sizes[0] || 'M';

        const image = toggleBtn.getAttribute('data-image') || card.querySelector('img')?.getAttribute('src') || 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=160&q=80';
        const url = toggleBtn.getAttribute('data-url') || card.querySelector('a')?.getAttribute('href') || '/collections/all';
        const handle = toggleBtn.getAttribute('data-handle') || card.querySelector('[data-quick-add-modal]')?.getAttribute('data-quick-add-modal') || (url ? url.split('/products/')[1]?.split('?')[0] : '') || '';
        const variantId = toggleBtn.getAttribute('data-variant-id') || card.querySelector('[name="id"]')?.value || card.querySelector('[data-quick-add-id]')?.getAttribute('data-quick-add-id') || '1';

        const availableAttr = toggleBtn.getAttribute('data-available');
        const available = availableAttr !== 'false' && availableAttr !== 'null';

        const items = this.getWishlistItems();
        const existingIndex = items.findIndex(i => i.title === title);

        if (existingIndex > -1) {
          // Remove from wishlist
          this.removeWishlistItem(existingIndex);
        } else {
          // Add to wishlist
          this.addWishlistItem({ title, price, comparePrice, color, colors, size, sizes, image, url, handle, variantId, available });
        }
      }

      // Remove item inside Wishlist Drawer
      const removeBtn = e.target.closest('[data-wishlist-remove-index]');
      if (removeBtn) {
        e.preventDefault();
        const index = parseInt(removeBtn.getAttribute('data-wishlist-remove-index'), 10);
        this.removeWishlistItem(index);
      }
    });
  }

  getWishlistItems() {
    try {
      return JSON.parse(localStorage.getItem(this.wishlistKey)) || [];
    } catch (e) {
      return [];
    }
  }

  addWishlistItem(item) {
    const items = this.getWishlistItems();
    const exists = items.some(i => i.title === item.title);
    if (!exists) {
      items.push(item);
      localStorage.setItem(this.wishlistKey, JSON.stringify(items));
    }
    this.renderWishlistDrawer();
    this.updateWishlistActiveButtons();
    this.openDrawer('wishlist-drawer');
  }

  removeWishlistItem(index) {
    const items = this.getWishlistItems();
    items.splice(index, 1);
    localStorage.setItem(this.wishlistKey, JSON.stringify(items));
    this.renderWishlistDrawer();
    this.updateWishlistActiveButtons();
  }

  updateWishlistActiveButtons() {
    const items = this.getWishlistItems();
    const buttons = document.querySelectorAll('[data-wishlist-toggle], [data-wishlist-add]');

    buttons.forEach(btn => {
      const card = btn.closest('.product-card') || btn.closest('.product-single-details') || document;
      const title = btn.getAttribute('data-title') || card.querySelector('.product-card-title, .product-single-title')?.textContent?.trim() || '';
      
      const isSaved = items.some(i => i.title === title);
      const textSpan = btn.querySelector('[data-wishlist-btn-text]');
      const svgPath = btn.querySelector('svg path, .wishlist-heart-svg path');

      btn.classList.toggle('is-active', isSaved);

      if (isSaved) {
        btn.style.color = '#e63946';
        if (svgPath) {
          svgPath.setAttribute('fill', '#e63946');
          svgPath.setAttribute('stroke', '#e63946');
        }
        if (textSpan) {
          textSpan.textContent = 'Saved in Wishlist ♥';
        }
      } else {
        btn.style.color = '';
        if (svgPath) {
          svgPath.setAttribute('fill', 'none');
          svgPath.setAttribute('stroke', 'currentColor');
        }
        if (textSpan) {
          textSpan.textContent = 'Add to Wishlist ♡';
        }
      }
    });
  }

  renderWishlistDrawer() {
    const items = this.getWishlistItems();
    const countBadges = document.querySelectorAll('[data-wishlist-count]');
    const listContainer = document.getElementById('wishlist-drawer-items-list');

    if (countBadges) {
      countBadges.forEach(badge => badge.textContent = items.length);
    }

    if (!listContainer) return;

    if (items.length === 0) {
      listContainer.innerHTML = `
        <div id="wishlist-drawer-empty" style="text-align: center; padding: 4rem 1rem;">
          <div style="font-size: 2.5rem; margin-bottom: 0.75rem; color: var(--text-muted);">♡</div>
          <h4 style="font-size: 1.1rem; text-transform: uppercase; margin-bottom: 0.5rem;">YOUR WISHLIST IS EMPTY</h4>
          <p style="font-size: 0.85rem; color: var(--text-muted); margin-bottom: 1.5rem; line-height: 1.5;">
            Save your favorite heavyweight tees, oversized hoodies, and drop pieces for quick access.
          </p>
          <a href="/collections/all" class="btn btn-primary btn-sm btn-ripple" data-drawer-close style="display: inline-flex; align-items: center; justify-content: center; text-decoration: none;">
            EXPLORE NEW ARRIVALS
          </a>
        </div>
      `;
      return;
    }

    listContainer.innerHTML = items.map((item, index) => {
      const productHandle = item.handle || (item.url ? item.url.split('/products/')[1]?.split('?')[0] : '') || '';

      return `
        <div class="wishlist-drawer-item" style="display: grid; grid-template-columns: 80px 1fr auto; gap: 0.85rem; padding: 0.85rem; background: #FFFFFF; border: 1px solid #EAEAE4; border-radius: 10px; align-items: center;">
          <img src="${item.image}" alt="${item.title}" class="wishlist-item-image" style="width: 80px; aspect-ratio: 3/4; object-fit: cover; border-radius: 6px;" loading="lazy">
          <div style="display: flex; flex-direction: column; gap: 0.25rem;">
            <h4 class="wishlist-item-title" style="font-size: 0.9rem; font-weight: 800; margin: 0; line-height: 1.2;">
              <a href="${item.url}" style="color: #111111; text-decoration: none;">${item.title}</a>
            </h4>
            <p class="wishlist-item-price" style="font-size: 0.85rem; font-weight: 800; color: #111111; margin: 0; display: flex; align-items: center; gap: 0.4rem;">
              <span>${item.price}</span>
              ${item.comparePrice ? `<span style="font-size: 0.775rem; color: #999999; text-decoration: line-through; font-weight: 500;">${item.comparePrice}</span>` : ''}
            </p>
            
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.35rem; flex-wrap: wrap;">
              ${item.available === false ? `
                <button type="button" class="btn btn-secondary btn-sm" disabled style="padding: 0.4rem 0.75rem; font-size: 0.725rem; font-weight: 800; text-transform: uppercase; opacity: 0.6; cursor: not-allowed; background: #E0E0E0; color: #666666; border: none;">SOLD OUT</button>
              ` : `
                <button type="button" class="btn btn-primary btn-sm btn-ripple" style="padding: 0.4rem 0.8rem; font-size: 0.725rem; font-weight: 800; text-transform: uppercase;" data-quick-add-modal="${productHandle}">SELECT OPTION</button>
              `}
            </div>
          </div>

          <button type="button" data-wishlist-remove-index="${index}" title="Remove item" style="color: #EB001B; font-size: 0.75rem; font-weight: 700; text-decoration: underline; background: none; border: none; cursor: pointer; padding: 0; align-self: start;">
            Remove
          </button>
        </div>
      `;
    }).join('');
  }

  /* ------------------------------------------------------------------------
     13. Product Gallery Engine (Slider, Pan Zoom, Lightbox Modal)
     ------------------------------------------------------------------------ */
  initProductGallery() {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      const slider = gallery.querySelector('[data-gallery-slider]');
      const slides = gallery.querySelectorAll('[data-gallery-slide]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const prevBtn = gallery.querySelector('[data-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-gallery-next]');
      const counterCur = gallery.querySelector('[data-gallery-current-index]');
      
      const enableZoom = gallery.getAttribute('data-enable-zoom') !== 'false';
      const enableLightbox = gallery.getAttribute('data-enable-lightbox') !== 'false';
      const zoomContainers = gallery.querySelectorAll('[data-zoom-container]');

      const lightbox = gallery.querySelector('[data-gallery-lightbox]');
      const openLightboxBtn = gallery.querySelector('[data-open-lightbox]');

      let currentIndex = 0;
      const slideCount = slides.length;
      if (!slideCount) return;

      // Update slide position & active states
      const goToSlide = (index) => {
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;
        currentIndex = index;

        // Slide track transform
        if (slider) {
          slider.style.transform = `translateX(-${currentIndex * 100}%)`;
        }

        // Active slide class
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === currentIndex);
        });

        // Active thumbnail state & scroll into view
        thumbs.forEach((thumb, i) => {
          const isActive = i === currentIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) {
            const parent = thumb.parentElement;
            if (parent && parent.scrollWidth > parent.clientWidth) {
              parent.scrollTo({
                left: thumb.offsetLeft - parent.clientWidth / 2 + thumb.clientWidth / 2,
                behavior: 'smooth'
              });
            }
          }
        });

        // Update counter
        if (counterCur) {
          counterCur.textContent = currentIndex + 1;
        }
      };

      // Color-based image switcher method
      const switchImageByColor = (colorName, mediaId) => {
        if (!colorName && !mediaId) return;

        let targetIndex = -1;

        // 1. Match by Shopify mediaId
        if (mediaId) {
          slides.forEach((slide, idx) => {
            if (slide.getAttribute('data-media-id') === String(mediaId)) {
              targetIndex = idx;
            }
          });
        }

        // 2. Match by data-color on slides or thumbs
        if (targetIndex === -1 && colorName) {
          const searchColor = String(colorName).trim().toLowerCase();
          slides.forEach((slide, idx) => {
            const slideColor = (slide.getAttribute('data-color') || slide.querySelector('img')?.getAttribute('alt') || '').toLowerCase();
            if (slideColor && (slideColor === searchColor || slideColor.includes(searchColor) || searchColor.includes(slideColor))) {
              if (targetIndex === -1) targetIndex = idx;
            }
          });
        }

        // 3. Fallback color image mapping if no slide index matched
        const colorImageMap = {
          'ash grey': 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=1200&q=80',
          'ash gray': 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=1200&q=80',
          'grey': 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=1200&q=80',
          'washed black': 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=1200&q=80',
          'vintage black': 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=1200&q=80',
          'black': 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=1200&q=80',
          'vintage white': 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&w=1200&q=80',
          'off-white': 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&w=1200&q=80',
          'white': 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&w=1200&q=80',
          'olive': 'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=1200&q=80',
          'sage': 'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=1200&q=80',
          'charcoal': 'https://images.unsplash.com/photo-1576995853123-5a10305d93c0?auto=format&fit=crop&w=1200&q=80',
          'acid wash': 'https://images.unsplash.com/photo-1576995853123-5a10305d93c0?auto=format&fit=crop&w=1200&q=80'
        };

        if (targetIndex !== -1) {
          goToSlide(targetIndex);
        } else if (colorName) {
          const key = String(colorName).trim().toLowerCase();
          const mappedSrc = colorImageMap[key];
          if (mappedSrc) {
            const activeSlide = slides[currentIndex] || slides[0];
            const activeImg = activeSlide?.querySelector('img');
            const zoomContainer = activeSlide?.querySelector('[data-zoom-container]');
            if (activeImg) {
              activeImg.style.transition = 'opacity 0.2s ease';
              activeImg.style.opacity = '0.3';
              setTimeout(() => {
                activeImg.src = mappedSrc;
                activeImg.style.opacity = '1';
              }, 120);
            }
            if (zoomContainer) {
              zoomContainer.setAttribute('data-high-res', mappedSrc.replace('w=1200', 'w=2400'));
            }
          }
        }
      };

      // Attach controller to DOM element
      gallery._galleryController = { goToSlide, switchImageByColor };

      // Arrow Listeners
      if (prevBtn) prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex + 1);
      });

      // Thumbnail Listeners
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const targetIndex = parseInt(thumb.getAttribute('data-gallery-thumb'), 10);
          if (!isNaN(targetIndex)) goToSlide(targetIndex);
        });
      });

      // Touch Drag / Swipe Support for Main Slider
      if (slider) {
        let touchStartX = 0;
        let touchEndX = 0;

        slider.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        slider.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 40) {
            if (diff > 0) goToSlide(currentIndex + 1);
            else goToSlide(currentIndex - 1);
          }
        }, { passive: true });
      }

      // Hover Pan-Zoom Engine
      if (enableZoom) {
        zoomContainers.forEach((container) => {
          const img = container.querySelector('[data-gallery-image]');
          if (!img) return;

          let isHovered = false;

          container.addEventListener('mouseenter', () => {
            isHovered = true;
            container.classList.add('is-zoomed');
          });

          container.addEventListener('mouseleave', () => {
            isHovered = false;
            container.classList.remove('is-zoomed');
            img.style.transformOrigin = 'center center';
          });

          container.addEventListener('mousemove', (e) => {
            if (!isHovered) return;
            const rect = container.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = `${x}% ${y}%`;
          });
        });
      }

      // Lightbox Engine
      if (enableLightbox && lightbox) {
        // Move lightbox to document.body to ensure high z-index stacking above all sticky product elements
        if (lightbox.parentElement !== document.body) {
          document.body.appendChild(lightbox);
        }
        const closeBtns = lightbox.querySelectorAll('[data-close-lightbox]');
        const lightboxImg = lightbox.querySelector('[data-lightbox-img]');
        const lightboxCur = lightbox.querySelector('[data-lightbox-current]');
        const lightboxTot = lightbox.querySelector('[data-lightbox-total]');
        const lightboxPrev = lightbox.querySelector('[data-lightbox-prev]');
        const lightboxNext = lightbox.querySelector('[data-lightbox-next]');
        const zoomInBtn = lightbox.querySelector('[data-lightbox-zoom-in]');
        const zoomOutBtn = lightbox.querySelector('[data-lightbox-zoom-out]');
        const zoomWrapper = lightbox.querySelector('[data-lightbox-zoom-wrapper]');
        const lightboxStage = lightbox.querySelector('[data-lightbox-stage]');

        let lightboxIndex = 0;
        let lightboxZoomScale = 1;
        let isPanDragging = false;
        let panStartX = 0, panStartY = 0;
        let currentPanX = 0, currentPanY = 0;
        let lastPanX = 0, lastPanY = 0;

        const updateLightboxTransform = (animate = false) => {
          if (!zoomWrapper) return;
          if (animate) {
            zoomWrapper.style.transition = 'transform 0.25s cubic-bezier(0.16, 1, 0.3, 1)';
          } else {
            zoomWrapper.style.transition = 'none';
          }

          if (lightboxZoomScale <= 1) {
            zoomWrapper.style.transform = 'translate3d(0, 0, 0) scale(1)';
            if (lightboxStage) lightboxStage.style.cursor = 'zoom-in';
          } else {
            zoomWrapper.style.transform = `translate3d(${currentPanX}px, ${currentPanY}px, 0) scale(${lightboxZoomScale})`;
            if (lightboxStage) lightboxStage.style.cursor = isPanDragging ? 'grabbing' : 'grab';
          }
        };

        const resetLightboxZoom = () => {
          lightboxZoomScale = 1;
          currentPanX = 0;
          currentPanY = 0;
          lastPanX = 0;
          lastPanY = 0;
          isPanDragging = false;
          updateLightboxTransform(true);
        };

        const setZoomScale = (newScale) => {
          lightboxZoomScale = Math.min(3.5, Math.max(1, newScale));
          if (lightboxZoomScale === 1) {
            currentPanX = 0;
            currentPanY = 0;
            lastPanX = 0;
            lastPanY = 0;
          }
          updateLightboxTransform(true);
        };

        const updateLightboxImage = (index) => {
          if (index < 0) index = slideCount - 1;
          if (index >= slideCount) index = 0;
          lightboxIndex = index;

          const currentSlide = slides[lightboxIndex];
          if (!currentSlide) return;

          const zoomContainer = currentSlide.querySelector('[data-zoom-container]');
          const highRes = zoomContainer ? zoomContainer.getAttribute('data-high-res') : null;
          const slideImg = currentSlide.querySelector('[data-gallery-image]');
          const src = highRes || (slideImg ? slideImg.src : '');

          if (lightboxImg) {
            lightboxImg.src = src;
            lightboxImg.alt = slideImg ? slideImg.alt : '';
          }

          if (lightboxCur) lightboxCur.textContent = lightboxIndex + 1;
          if (lightboxTot) lightboxTot.textContent = slideCount;

          resetLightboxZoom();
        };

        const openLightbox = (index) => {
          updateLightboxImage(index);
          lightbox.classList.add('is-active');
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        };

        const closeLightbox = () => {
          lightbox.classList.remove('is-active');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          resetLightboxZoom();
        };

        // Open Lightbox Trigger button
        if (openLightboxBtn) {
          openLightboxBtn.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox(currentIndex);
          });
        }

        // Open lightbox on image click if requested
        slides.forEach((slide, idx) => {
          const imgContainer = slide.querySelector('[data-zoom-container]');
          if (imgContainer) {
            imgContainer.addEventListener('click', (e) => {
              if (e.target.closest('.gallery-nav-btn') || e.target.closest('.gallery-lightbox-trigger')) return;
              openLightbox(idx);
            });
          }
        });

        // Close Listeners
        closeBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            closeLightbox();
          });
        });

        // Lightbox Navigation
        if (lightboxPrev) {
          lightboxPrev.addEventListener('click', (e) => {
            e.preventDefault();
            updateLightboxImage(lightboxIndex - 1);
          });
        }
        if (lightboxNext) {
          lightboxNext.addEventListener('click', (e) => {
            e.preventDefault();
            updateLightboxImage(lightboxIndex + 1);
          });
        }

        // Zoom In / Zoom Out Controls inside Lightbox
        if (zoomInBtn) {
          zoomInBtn.addEventListener('click', (e) => {
            e.preventDefault();
            setZoomScale(lightboxZoomScale + 0.5);
          });
        }
        if (zoomOutBtn) {
          zoomOutBtn.addEventListener('click', (e) => {
            e.preventDefault();
            setZoomScale(lightboxZoomScale - 0.5);
          });
        }

        // Drag to Pan Engine for Lightbox Stage (Mouse & Touch)
        if (lightboxStage) {
          // Prevent browser native image drag ghosting
          lightboxStage.addEventListener('dragstart', (e) => e.preventDefault());

          // Mouse Events
          lightboxStage.addEventListener('mousedown', (e) => {
            if (lightboxZoomScale <= 1) return;
            e.preventDefault();
            isPanDragging = true;
            panStartX = e.clientX - lastPanX;
            panStartY = e.clientY - lastPanY;
            updateLightboxTransform(false);
          });

          window.addEventListener('mousemove', (e) => {
            if (!isPanDragging || lightboxZoomScale <= 1) return;
            e.preventDefault();
            currentPanX = e.clientX - panStartX;
            currentPanY = e.clientY - panStartY;
            updateLightboxTransform(false);
          });

          window.addEventListener('mouseup', () => {
            if (!isPanDragging) return;
            isPanDragging = false;
            lastPanX = currentPanX;
            lastPanY = currentPanY;
            updateLightboxTransform(false);
          });

          // Touch Events for Mobile
          lightboxStage.addEventListener('touchstart', (e) => {
            if (lightboxZoomScale <= 1 || e.touches.length !== 1) return;
            isPanDragging = true;
            panStartX = e.touches[0].clientX - lastPanX;
            panStartY = e.touches[0].clientY - lastPanY;
          }, { passive: true });

          lightboxStage.addEventListener('touchmove', (e) => {
            if (!isPanDragging || lightboxZoomScale <= 1 || e.touches.length !== 1) return;
            currentPanX = e.touches[0].clientX - panStartX;
            currentPanY = e.touches[0].clientY - panStartY;
            updateLightboxTransform(false);
          }, { passive: true });

          lightboxStage.addEventListener('touchend', () => {
            if (!isPanDragging) return;
            isPanDragging = false;
            lastPanX = currentPanX;
            lastPanY = currentPanY;
            updateLightboxTransform(false);
          });

          // Double Click / Double Tap to Toggle Zoom & Pan Mode
          lightboxStage.addEventListener('dblclick', (e) => {
            e.preventDefault();
            if (lightboxZoomScale > 1) {
              resetLightboxZoom();
            } else {
              setZoomScale(2.5);
            }
          });
        }

        // Keyboard navigation for Lightbox
        document.addEventListener('keydown', (e) => {
          if (!lightbox.classList.contains('is-active')) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') updateLightboxImage(lightboxIndex - 1);
          if (e.key === 'ArrowRight') updateLightboxImage(lightboxIndex + 1);
        });
      }
    });
  }

  /* ------------------------------------------------------------------------
     Collection Filters: Sort-by, Collapsible Groups, Filter Form Submit
     ------------------------------------------------------------------------ */
  initCollectionFilters() {
    // --- Sort-by: redirect preserving existing filter params ---
    const sortSelects = document.querySelectorAll('[data-sort-by]');
    sortSelects.forEach(sortSelect => {
      sortSelect.addEventListener('change', () => {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('sort_by', sortSelect.value);
        window.location.href = newUrl.toString();
      });
    });

    // --- Filter Form: Native GET submit & Checkbox State Handler ---
    const filterForm = document.getElementById('FilterForm');
    if (filterForm) {
      // Auto-apply on checkbox change (instant filtering & active visual state toggle)
      filterForm.querySelectorAll('[data-filter-checkbox]').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          const parentLabel = checkbox.closest('.filter-checkbox');
          if (parentLabel) {
            parentLabel.classList.toggle('is-active', checkbox.checked);
          }
          filterForm.submit();
        });
      });
    }

    // --- Collapsible filter groups ---
    document.querySelectorAll('[data-filter-toggle]').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('[data-filter-group]');
        const body  = group.querySelector('.filter-group__body');
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        body.classList.toggle('is-collapsed', isExpanded);
      });
    });
  }

  /* ------------------------------------------------------------------------
     Available Offers Slider & Coupon Code Copying
     ------------------------------------------------------------------------ */
  initOffersSlider() {
    const slider = document.querySelector('[data-offers-slider]');
    const prevBtn = document.querySelector('[data-offers-prev]');
    const nextBtn = document.querySelector('[data-offers-next]');

    if (slider) {
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          slider.scrollBy({ left: -220, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          slider.scrollBy({ left: 220, behavior: 'smooth' });
        });
      }
    }

    // Coupon code copy buttons
    document.addEventListener('click', (e) => {
      const copyBtn = e.target.closest('[data-copy-code]');
      if (copyBtn) {
        const code = copyBtn.getAttribute('data-copy-code');
        if (code) {
          navigator.clipboard.writeText(code).then(() => {
            const originalText = copyBtn.textContent;
            copyBtn.textContent = 'COPIED!';
            copyBtn.style.backgroundColor = '#000000';
            setTimeout(() => {
              copyBtn.textContent = originalText;
              copyBtn.style.backgroundColor = '#0D652D';
            }, 2000);
          }).catch(err => {
            console.error('Failed to copy code:', err);
          });
        }
      }
    });
  }

  initProductCardSwatches() {
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-card-swatch]');
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();

      const card = swatch.closest('.product-card');
      if (!card) return;

      const swatches = card.querySelectorAll('[data-card-swatch]');
      swatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      const variantImg = swatch.getAttribute('data-variant-img');
      const primaryImg = card.querySelector('.product-card-img.primary-img');
      if (primaryImg && variantImg) {
        primaryImg.src = variantImg;
      }
    });

    document.addEventListener('mouseover', (e) => {
      const swatch = e.target.closest('[data-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('.product-card');
      if (!card) return;

      const variantImg = swatch.getAttribute('data-variant-img');
      const primaryImg = card.querySelector('.product-card-img.primary-img');
      if (primaryImg && variantImg) {
        primaryImg.src = variantImg;
      }
    });
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const instance = new ExclothTheme();
  window.exclothApp = instance;
  window.ShopifyTheme = instance;
});
